// Generated relationship classes
// This file is auto-generated - do not edit manually

// Edge-property enum imports
import type { AllocationKind, AttachmentResolution, ConstraintRole } from '../rflp/enums';

// Import Zod schemas for validation
import { ActionWriteAPISchema } from '../rflp/types/action';
import { ActionDefinitionWriteAPISchema } from '../sysml/types/actiondefinition';
import { ActionInputParameterWriteAPISchema } from '../rflp/types/actioninputparameter';
import { ActionOutputParameterWriteAPISchema } from '../rflp/types/actionoutputparameter';
import { ActionParameterWriteAPISchema } from '../rflp/types/actionparameter';
import { AnalysisRecordWriteAPISchema } from '../rflp/types/analysisrecord';
import { AnswerWriteAPISchema } from '../tasks/types/answer';
import { AttributeWriteAPISchema } from '../rflp/types/attribute';
import { AttributeDefinitionWriteAPISchema } from '../sysml/types/attributedefinition';
import { AttributeValueWriteAPISchema } from '../rflp/types/attributevalue';
import { CatalogNodeWriteAPISchema } from '../shared/types/catalognode';
import { ChangeImpactWriteAPISchema } from '../rflp/types/changeimpact';
import { ChangeProposalWriteAPISchema } from '../rflp/types/changeproposal';
import { ConcernWriteAPISchema } from '../rflp/types/concern';
import { ConnectionWriteAPISchema } from '../rflp/types/connection';
import { ConstraintWriteAPISchema } from '../rflp/types/constraint';
import { ControlPortWriteAPISchema } from '../rflp/types/controlport';
import { DanglingPortResolutionTaskWriteAPISchema } from '../managers/types/danglingportresolutiontask';
import { DerivedExpressionWriteAPISchema } from '../rflp/types/derivedexpression';
import { DerivedValueWriteAPISchema } from '../rflp/types/derivedvalue';
import { EntityExtractionTaskWriteAPISchema } from '../managers/types/entityextractiontask';
import { ExpressionWriteAPISchema } from '../rflp/types/expression';
import { GitHubRepoWriteAPISchema } from '../rflp/types/githubrepo';
import { GlossaryTermWriteAPISchema } from '../rflp/types/glossaryterm';
import { GroupWriteAPISchema } from '../base/types/group';
import { IndustryWriteAPISchema } from '../base/types/industry';
import { InterfacePortWriteAPISchema } from '../rflp/types/interfaceport';
import { IntrinsicExpansionTaskWriteAPISchema } from '../managers/types/intrinsicexpansiontask';
import { InviteWriteAPISchema } from '../base/types/invite';
import { IslandPinWriteAPISchema } from '../rflp/types/islandpin';
import { IslandRootWriteAPISchema } from '../shared/types/islandroot';
import { ItemWriteAPISchema } from '../rflp/types/item';
import { ItemFlowWriteAPISchema } from '../rflp/types/itemflow';
import { LLMTaskWriteAPISchema } from '../llm_task/types/llmtask';
import { LogicalPartWriteAPISchema } from '../rflp/types/logicalpart';
import { MBSE_ActionWriteAPISchema } from '../mbse/types/mbse_action';
import { MBSE_AttributeWriteAPISchema } from '../mbse/types/mbse_attribute';
import { MBSE_PackageWriteAPISchema } from '../mbse/types/mbse_package';
import { MBSE_PartWriteAPISchema } from '../mbse/types/mbse_part';
import { MBSE_PortWriteAPISchema } from '../mbse/types/mbse_port';
import { MBSE_RequirementWriteAPISchema } from '../mbse/types/mbse_requirement';
import { ModelRequestWriteAPISchema } from '../chat/types/modelrequest';
import { ModelResponseWriteAPISchema } from '../chat/types/modelresponse';
import { NumericAttributeWriteAPISchema } from '../rflp/types/numericattribute';
import { OrganisationWriteAPISchema } from '../base/types/organisation';
import { PDMActionWriteAPISchema } from '../pdm/types/pdmaction';
import { PDMPartWriteAPISchema } from '../pdm/types/pdmpart';
import { PDMPortWriteAPISchema } from '../pdm/types/pdmport';
import { PDMProductWriteAPISchema } from '../pdm/types/pdmproduct';
import { PDMRequirementWriteAPISchema } from '../pdm/types/pdmrequirement';
import { PDMSupplyChainCriteriaWriteAPISchema } from '../pdm/types/pdmsupplychaincriteria';
import { PartWriteAPISchema } from '../rflp/types/part';
import { PartDefinitionWriteAPISchema } from '../sysml/types/partdefinition';
import { PhysicalPartWriteAPISchema } from '../rflp/types/physicalpart';
import { PhysicsPortWriteAPISchema } from '../rflp/types/physicsport';
import { PortWriteAPISchema } from '../rflp/types/port';
import { ProjectWriteAPISchema } from '../rflp/types/project';
import { ProposalBatchWriteAPISchema } from '../rflp/types/proposalbatch';
import { QuestionWriteAPISchema } from '../tasks/types/question';
import { QuestionnaireWriteAPISchema } from '../tasks/types/questionnaire';
import { RFLPElementWriteAPISchema } from '../rflp/types/rflpelement';
import { RequirementWriteAPISchema } from '../rflp/types/requirement';
import { RequirementDefinitionWriteAPISchema } from '../sysml/types/requirementdefinition';
import { RequirementSatisfactionTaskWriteAPISchema } from '../managers/types/requirementsatisfactiontask';
import { ResponsePartWriteAPISchema } from '../chat/types/responsepart';
import { ScopedNodeWriteAPISchema } from '../shared/types/scopednode';
import { SecurityScopeWriteAPISchema } from '../shared/types/securityscope';
import { SoftwarePartWriteAPISchema } from '../rflp/types/softwarepart';
import { SourceDocumentWriteAPISchema } from '../rflp/types/sourcedocument';
import { StakeholderNeedWriteAPISchema } from '../rflp/types/stakeholderneed';
import { StandardWriteAPISchema } from '../rflp/types/standard';
import { StepWriteAPISchema } from '../chat/types/step';
import { StepTaskWriteAPISchema } from '../llm_task/types/steptask';
import { SuccessionWriteAPISchema } from '../rflp/types/succession';
import { SysMLConstraintWriteAPISchema } from '../sysml/types/sysmlconstraint';
import { SysMLElementWriteAPISchema } from '../sysml/types/sysmlelement';
import { SysMLExpressionWriteAPISchema } from '../sysml/types/sysmlexpression';
import { SysMLNamespaceWriteAPISchema } from '../sysml/types/sysmlnamespace';
import { SysMLTypeWriteAPISchema } from '../sysml/types/sysmltype';
import { SysMLUnitWriteAPISchema } from '../sysml/types/sysmlunit';
import { SystemPromptWriteAPISchema } from '../chat/types/systemprompt';
import { TaskWriteAPISchema } from '../tasks/types/task';
import { ThreadWriteAPISchema } from '../chat/types/thread';
import { ThreadTaskWriteAPISchema } from '../llm_task/types/threadtask';
import { ToolCallPartWriteAPISchema } from '../chat/types/toolcallpart';
import { ToolCallResponseWriteAPISchema } from '../chat/types/toolcallresponse';
import { UnitWriteAPISchema } from '../rflp/types/unit';
import { UserWriteAPISchema } from '../base/types/user';
import { VersioningRowWriteAPISchema } from '../shared/types/versioningrow';
import { WorkspaceWriteAPISchema } from '../base/types/workspace';

import { z } from 'zod';
import { Relationship } from '@sourcepilot/framework/relationship';

// Infer types from Zod schemas
type ActionWriteAPI = z.infer<typeof ActionWriteAPISchema>;
type ActionDefinitionWriteAPI = z.infer<typeof ActionDefinitionWriteAPISchema>;
type ActionInputParameterWriteAPI = z.infer<typeof ActionInputParameterWriteAPISchema>;
type ActionOutputParameterWriteAPI = z.infer<typeof ActionOutputParameterWriteAPISchema>;
type ActionParameterWriteAPI = z.infer<typeof ActionParameterWriteAPISchema>;
type AnalysisRecordWriteAPI = z.infer<typeof AnalysisRecordWriteAPISchema>;
type AnswerWriteAPI = z.infer<typeof AnswerWriteAPISchema>;
type AttributeWriteAPI = z.infer<typeof AttributeWriteAPISchema>;
type AttributeDefinitionWriteAPI = z.infer<typeof AttributeDefinitionWriteAPISchema>;
type AttributeValueWriteAPI = z.infer<typeof AttributeValueWriteAPISchema>;
type CatalogNodeWriteAPI = z.infer<typeof CatalogNodeWriteAPISchema>;
type ChangeImpactWriteAPI = z.infer<typeof ChangeImpactWriteAPISchema>;
type ChangeProposalWriteAPI = z.infer<typeof ChangeProposalWriteAPISchema>;
type ConcernWriteAPI = z.infer<typeof ConcernWriteAPISchema>;
type ConnectionWriteAPI = z.infer<typeof ConnectionWriteAPISchema>;
type ConstraintWriteAPI = z.infer<typeof ConstraintWriteAPISchema>;
type ControlPortWriteAPI = z.infer<typeof ControlPortWriteAPISchema>;
type DanglingPortResolutionTaskWriteAPI = z.infer<typeof DanglingPortResolutionTaskWriteAPISchema>;
type DerivedExpressionWriteAPI = z.infer<typeof DerivedExpressionWriteAPISchema>;
type DerivedValueWriteAPI = z.infer<typeof DerivedValueWriteAPISchema>;
type EntityExtractionTaskWriteAPI = z.infer<typeof EntityExtractionTaskWriteAPISchema>;
type ExpressionWriteAPI = z.infer<typeof ExpressionWriteAPISchema>;
type GitHubRepoWriteAPI = z.infer<typeof GitHubRepoWriteAPISchema>;
type GlossaryTermWriteAPI = z.infer<typeof GlossaryTermWriteAPISchema>;
type GroupWriteAPI = z.infer<typeof GroupWriteAPISchema>;
type IndustryWriteAPI = z.infer<typeof IndustryWriteAPISchema>;
type InterfacePortWriteAPI = z.infer<typeof InterfacePortWriteAPISchema>;
type IntrinsicExpansionTaskWriteAPI = z.infer<typeof IntrinsicExpansionTaskWriteAPISchema>;
type InviteWriteAPI = z.infer<typeof InviteWriteAPISchema>;
type IslandPinWriteAPI = z.infer<typeof IslandPinWriteAPISchema>;
type IslandRootWriteAPI = z.infer<typeof IslandRootWriteAPISchema>;
type ItemWriteAPI = z.infer<typeof ItemWriteAPISchema>;
type ItemFlowWriteAPI = z.infer<typeof ItemFlowWriteAPISchema>;
type LLMTaskWriteAPI = z.infer<typeof LLMTaskWriteAPISchema>;
type LogicalPartWriteAPI = z.infer<typeof LogicalPartWriteAPISchema>;
type MBSE_ActionWriteAPI = z.infer<typeof MBSE_ActionWriteAPISchema>;
type MBSE_AttributeWriteAPI = z.infer<typeof MBSE_AttributeWriteAPISchema>;
type MBSE_PackageWriteAPI = z.infer<typeof MBSE_PackageWriteAPISchema>;
type MBSE_PartWriteAPI = z.infer<typeof MBSE_PartWriteAPISchema>;
type MBSE_PortWriteAPI = z.infer<typeof MBSE_PortWriteAPISchema>;
type MBSE_RequirementWriteAPI = z.infer<typeof MBSE_RequirementWriteAPISchema>;
type ModelRequestWriteAPI = z.infer<typeof ModelRequestWriteAPISchema>;
type ModelResponseWriteAPI = z.infer<typeof ModelResponseWriteAPISchema>;
type NumericAttributeWriteAPI = z.infer<typeof NumericAttributeWriteAPISchema>;
type OrganisationWriteAPI = z.infer<typeof OrganisationWriteAPISchema>;
type PDMActionWriteAPI = z.infer<typeof PDMActionWriteAPISchema>;
type PDMPartWriteAPI = z.infer<typeof PDMPartWriteAPISchema>;
type PDMPortWriteAPI = z.infer<typeof PDMPortWriteAPISchema>;
type PDMProductWriteAPI = z.infer<typeof PDMProductWriteAPISchema>;
type PDMRequirementWriteAPI = z.infer<typeof PDMRequirementWriteAPISchema>;
type PDMSupplyChainCriteriaWriteAPI = z.infer<typeof PDMSupplyChainCriteriaWriteAPISchema>;
type PartWriteAPI = z.infer<typeof PartWriteAPISchema>;
type PartDefinitionWriteAPI = z.infer<typeof PartDefinitionWriteAPISchema>;
type PhysicalPartWriteAPI = z.infer<typeof PhysicalPartWriteAPISchema>;
type PhysicsPortWriteAPI = z.infer<typeof PhysicsPortWriteAPISchema>;
type PortWriteAPI = z.infer<typeof PortWriteAPISchema>;
type ProjectWriteAPI = z.infer<typeof ProjectWriteAPISchema>;
type ProposalBatchWriteAPI = z.infer<typeof ProposalBatchWriteAPISchema>;
type QuestionWriteAPI = z.infer<typeof QuestionWriteAPISchema>;
type QuestionnaireWriteAPI = z.infer<typeof QuestionnaireWriteAPISchema>;
type RFLPElementWriteAPI = z.infer<typeof RFLPElementWriteAPISchema>;
type RequirementWriteAPI = z.infer<typeof RequirementWriteAPISchema>;
type RequirementDefinitionWriteAPI = z.infer<typeof RequirementDefinitionWriteAPISchema>;
type RequirementSatisfactionTaskWriteAPI = z.infer<typeof RequirementSatisfactionTaskWriteAPISchema>;
type ResponsePartWriteAPI = z.infer<typeof ResponsePartWriteAPISchema>;
type ScopedNodeWriteAPI = z.infer<typeof ScopedNodeWriteAPISchema>;
type SecurityScopeWriteAPI = z.infer<typeof SecurityScopeWriteAPISchema>;
type SoftwarePartWriteAPI = z.infer<typeof SoftwarePartWriteAPISchema>;
type SourceDocumentWriteAPI = z.infer<typeof SourceDocumentWriteAPISchema>;
type StakeholderNeedWriteAPI = z.infer<typeof StakeholderNeedWriteAPISchema>;
type StandardWriteAPI = z.infer<typeof StandardWriteAPISchema>;
type StepWriteAPI = z.infer<typeof StepWriteAPISchema>;
type StepTaskWriteAPI = z.infer<typeof StepTaskWriteAPISchema>;
type SuccessionWriteAPI = z.infer<typeof SuccessionWriteAPISchema>;
type SysMLConstraintWriteAPI = z.infer<typeof SysMLConstraintWriteAPISchema>;
type SysMLElementWriteAPI = z.infer<typeof SysMLElementWriteAPISchema>;
type SysMLExpressionWriteAPI = z.infer<typeof SysMLExpressionWriteAPISchema>;
type SysMLNamespaceWriteAPI = z.infer<typeof SysMLNamespaceWriteAPISchema>;
type SysMLTypeWriteAPI = z.infer<typeof SysMLTypeWriteAPISchema>;
type SysMLUnitWriteAPI = z.infer<typeof SysMLUnitWriteAPISchema>;
type SystemPromptWriteAPI = z.infer<typeof SystemPromptWriteAPISchema>;
type TaskWriteAPI = z.infer<typeof TaskWriteAPISchema>;
type ThreadWriteAPI = z.infer<typeof ThreadWriteAPISchema>;
type ThreadTaskWriteAPI = z.infer<typeof ThreadTaskWriteAPISchema>;
type ToolCallPartWriteAPI = z.infer<typeof ToolCallPartWriteAPISchema>;
type ToolCallResponseWriteAPI = z.infer<typeof ToolCallResponseWriteAPISchema>;
type UnitWriteAPI = z.infer<typeof UnitWriteAPISchema>;
type UserWriteAPI = z.infer<typeof UserWriteAPISchema>;
type VersioningRowWriteAPI = z.infer<typeof VersioningRowWriteAPISchema>;
type WorkspaceWriteAPI = z.infer<typeof WorkspaceWriteAPISchema>;

// Relationship classes with static metadata


// ActionBindsParameter: Action.bound_parameters -> ActionParameter.bound_to
export class ActionBindsParameter extends Relationship<ActionWriteAPI, ActionParameterWriteAPI> {
  static get relationshipName() { return 'ActionBindsParameter'; }
  static readonly originSchema = ActionWriteAPISchema;
  static readonly destSchema = ActionParameterWriteAPISchema;
  static readonly originModelNames = ['Action'] as const;
  static readonly destModelNames = ['ActionParameter'] as const;
  static get origin_property() { return 'bound_parameters'; }
  static get dest_property() { return 'bound_to'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ActionComposedOf: ActionDefinition.sub_actions -> ActionDefinition.parent_action
export class ActionComposedOf extends Relationship<ActionDefinitionWriteAPI, ActionDefinitionWriteAPI> {
  static get relationshipName() { return 'ActionComposedOf'; }
  static readonly originSchema = ActionDefinitionWriteAPISchema;
  static readonly destSchema = ActionDefinitionWriteAPISchema;
  static readonly originModelNames = ['ActionDefinition'] as const;
  static readonly destModelNames = ['ActionDefinition'] as const;
  static get origin_property() { return 'sub_actions'; }
  static get dest_property() { return 'parent_action'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// ActionHasInputParameters: Action.input_parameters -> ActionInputParameter.owner_action
export class ActionHasInputParameters extends Relationship<ActionWriteAPI, ActionInputParameterWriteAPI> {
  static get relationshipName() { return 'ActionHasInputParameters'; }
  static readonly originSchema = ActionWriteAPISchema;
  static readonly destSchema = ActionInputParameterWriteAPISchema;
  static readonly originModelNames = ['Action'] as const;
  static readonly destModelNames = ['ActionInputParameter'] as const;
  static get origin_property() { return 'input_parameters'; }
  static get dest_property() { return 'owner_action'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ActionHasOutputParameters: Action.output_parameters -> ActionOutputParameter.owner_action
export class ActionHasOutputParameters extends Relationship<ActionWriteAPI, ActionOutputParameterWriteAPI> {
  static get relationshipName() { return 'ActionHasOutputParameters'; }
  static readonly originSchema = ActionWriteAPISchema;
  static readonly destSchema = ActionOutputParameterWriteAPISchema;
  static readonly originModelNames = ['Action'] as const;
  static readonly destModelNames = ['ActionOutputParameter'] as const;
  static get origin_property() { return 'output_parameters'; }
  static get dest_property() { return 'owner_action'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ActionParameterTypedBy: ActionParameter.item -> Item.unknown
export class ActionParameterTypedBy extends Relationship<ActionParameterWriteAPI, ItemWriteAPI> {
  static get relationshipName() { return 'ActionParameterTypedBy'; }
  static readonly originSchema = ActionParameterWriteAPISchema;
  static readonly destSchema = ItemWriteAPISchema;
  static readonly originModelNames = ['ActionParameter'] as const;
  static readonly destModelNames = ['Item'] as const;
  static get origin_property() { return 'item'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ActionVerifiesRequirement: Action.verifies -> Requirement.verified_by_actions
export class ActionVerifiesRequirement extends Relationship<ActionWriteAPI, RequirementWriteAPI> {
  static get relationshipName() { return 'ActionVerifiesRequirement'; }
  static readonly originSchema = ActionWriteAPISchema;
  static readonly destSchema = RequirementWriteAPISchema;
  static readonly originModelNames = ['Action'] as const;
  static readonly destModelNames = ['Requirement'] as const;
  static get origin_property() { return 'verifies'; }
  static get dest_property() { return 'verified_by_actions'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// Allocation: ActionDefinition.allocated_to -> PartDefinition.allocated_actions
export class Allocation extends Relationship<ActionDefinitionWriteAPI, PartDefinitionWriteAPI> {
  static get relationshipName() { return 'Allocation'; }
  static readonly originSchema = ActionDefinitionWriteAPISchema;
  static readonly destSchema = PartDefinitionWriteAPISchema;
  static readonly originModelNames = ['ActionDefinition'] as const;
  static readonly destModelNames = ['PartDefinition'] as const;
  static get origin_property() { return 'allocated_to'; }
  static get dest_property() { return 'allocated_actions'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// AnalysesContent: LLMTask.analyses -> ScopedNode.unknown
export class AnalysesContent extends Relationship<LLMTaskWriteAPI, ScopedNodeWriteAPI> {
  static get relationshipName() { return 'AnalysesContent'; }
  static readonly originSchema = LLMTaskWriteAPISchema;
  static readonly destSchema = ScopedNodeWriteAPISchema;
  static readonly originModelNames = ['LLMTask'] as const;
  static readonly destModelNames = ['ScopedNode'] as const;
  static get origin_property() { return 'analyses'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// AnalysisRecordOfProject: AnalysisRecord.project -> Project.analysis_records
export class AnalysisRecordOfProject extends Relationship<AnalysisRecordWriteAPI, ProjectWriteAPI> {
  static get relationshipName() { return 'AnalysisRecordOfProject'; }
  static readonly originSchema = AnalysisRecordWriteAPISchema;
  static readonly destSchema = ProjectWriteAPISchema;
  static readonly originModelNames = ['AnalysisRecord'] as const;
  static readonly destModelNames = ['Project'] as const;
  static get origin_property() { return 'project'; }
  static get dest_property() { return 'analysis_records'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// AtScope: ScopedNode.security_scope -> SecurityScope.unknown
export class AtScope extends Relationship<ScopedNodeWriteAPI, SecurityScopeWriteAPI> {
  static get relationshipName() { return 'AtScope'; }
  static readonly originSchema = ScopedNodeWriteAPISchema;
  static readonly destSchema = SecurityScopeWriteAPISchema;
  static readonly originModelNames = ['ScopedNode'] as const;
  static readonly destModelNames = ['SecurityScope'] as const;
  static get origin_property() { return 'security_scope'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// AttributeInWorkspace: Attribute.workspace -> Workspace.unknown
export class AttributeInWorkspace extends Relationship<AttributeWriteAPI, WorkspaceWriteAPI> {
  static get relationshipName() { return 'AttributeInWorkspace'; }
  static readonly originSchema = AttributeWriteAPISchema;
  static readonly destSchema = WorkspaceWriteAPISchema;
  static readonly originModelNames = ['Attribute'] as const;
  static readonly destModelNames = ['Workspace'] as const;
  static get origin_property() { return 'workspace'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// AttributeValueHasUnitOverride: AttributeValue.unit_override -> Unit.unknown
export class AttributeValueHasUnitOverride extends Relationship<AttributeValueWriteAPI, UnitWriteAPI> {
  static get relationshipName() { return 'AttributeValueHasUnitOverride'; }
  static readonly originSchema = AttributeValueWriteAPISchema;
  static readonly destSchema = UnitWriteAPISchema;
  static readonly originModelNames = ['AttributeValue'] as const;
  static readonly destModelNames = ['Unit'] as const;
  static get origin_property() { return 'unit_override'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// AttributeValueOfAttribute: AttributeValue.attribute -> Attribute.values
export class AttributeValueOfAttribute extends Relationship<AttributeValueWriteAPI, AttributeWriteAPI> {
  static get relationshipName() { return 'AttributeValueOfAttribute'; }
  static readonly originSchema = AttributeValueWriteAPISchema;
  static readonly destSchema = AttributeWriteAPISchema;
  static readonly originModelNames = ['AttributeValue'] as const;
  static readonly destModelNames = ['Attribute'] as const;
  static get origin_property() { return 'attribute'; }
  static get dest_property() { return 'values'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// BelongsToIndustry: PDMProduct.industry -> Industry.unknown
export class BelongsToIndustry extends Relationship<PDMProductWriteAPI, IndustryWriteAPI> {
  static get relationshipName() { return 'BelongsToIndustry'; }
  static readonly originSchema = PDMProductWriteAPISchema;
  static readonly destSchema = IndustryWriteAPISchema;
  static readonly originModelNames = ['PDMProduct'] as const;
  static readonly destModelNames = ['Industry'] as const;
  static get origin_property() { return 'industry'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// BelongsToWorkspace: Task.workspace -> Workspace.tasks
export class BelongsToWorkspace extends Relationship<TaskWriteAPI, WorkspaceWriteAPI> {
  static get relationshipName() { return 'BelongsToWorkspace'; }
  static readonly originSchema = TaskWriteAPISchema;
  static readonly destSchema = WorkspaceWriteAPISchema;
  static readonly originModelNames = ['Task'] as const;
  static readonly destModelNames = ['Workspace'] as const;
  static get origin_property() { return 'workspace'; }
  static get dest_property() { return 'tasks'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// CatalogAt: CatalogNode.catalog_scope -> SecurityScope.unknown
export class CatalogAt extends Relationship<CatalogNodeWriteAPI, SecurityScopeWriteAPI> {
  static get relationshipName() { return 'CatalogAt'; }
  static readonly originSchema = CatalogNodeWriteAPISchema;
  static readonly destSchema = SecurityScopeWriteAPISchema;
  static readonly originModelNames = ['CatalogNode'] as const;
  static readonly destModelNames = ['SecurityScope'] as const;
  static get origin_property() { return 'catalog_scope'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ChangeImpactOfProject: ChangeImpact.project -> Project.change_impacts
export class ChangeImpactOfProject extends Relationship<ChangeImpactWriteAPI, ProjectWriteAPI> {
  static get relationshipName() { return 'ChangeImpactOfProject'; }
  static readonly originSchema = ChangeImpactWriteAPISchema;
  static readonly destSchema = ProjectWriteAPISchema;
  static readonly originModelNames = ['ChangeImpact'] as const;
  static readonly destModelNames = ['Project'] as const;
  static get origin_property() { return 'project'; }
  static get dest_property() { return 'change_impacts'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ChangeProposalInBatch: ProposalBatch.proposals -> ChangeProposal.batch
export class ChangeProposalInBatch extends Relationship<ProposalBatchWriteAPI, ChangeProposalWriteAPI> {
  static get relationshipName() { return 'ChangeProposalInBatch'; }
  static readonly originSchema = ProposalBatchWriteAPISchema;
  static readonly destSchema = ChangeProposalWriteAPISchema;
  static readonly originModelNames = ['ProposalBatch'] as const;
  static readonly destModelNames = ['ChangeProposal'] as const;
  static get origin_property() { return 'proposals'; }
  static get dest_property() { return 'batch'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ConcernHasStakeholder: Concern.stakeholders -> User.unknown
export class ConcernHasStakeholder extends Relationship<ConcernWriteAPI, UserWriteAPI> {
  static get relationshipName() { return 'ConcernHasStakeholder'; }
  static readonly originSchema = ConcernWriteAPISchema;
  static readonly destSchema = UserWriteAPISchema;
  static readonly originModelNames = ['Concern'] as const;
  static readonly destModelNames = ['User'] as const;
  static get origin_property() { return 'stakeholders'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ConnectionEndA: Connection.port_a -> Port.connections_as_a
export class ConnectionEndA extends Relationship<ConnectionWriteAPI, PortWriteAPI> {
  static get relationshipName() { return 'ConnectionEndA'; }
  static readonly originSchema = ConnectionWriteAPISchema;
  static readonly destSchema = PortWriteAPISchema;
  static readonly originModelNames = ['Connection'] as const;
  static readonly destModelNames = ['Port'] as const;
  static get origin_property() { return 'port_a'; }
  static get dest_property() { return 'connections_as_a'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ConnectionEndB: Connection.port_b -> Port.connections_as_b
export class ConnectionEndB extends Relationship<ConnectionWriteAPI, PortWriteAPI> {
  static get relationshipName() { return 'ConnectionEndB'; }
  static readonly originSchema = ConnectionWriteAPISchema;
  static readonly destSchema = PortWriteAPISchema;
  static readonly originModelNames = ['Connection'] as const;
  static readonly destModelNames = ['Port'] as const;
  static get origin_property() { return 'port_b'; }
  static get dest_property() { return 'connections_as_b'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ConstraintHasChildConstraints: Constraint.child_constraints -> Constraint.parent_constraint
export class ConstraintHasChildConstraints extends Relationship<ConstraintWriteAPI, ConstraintWriteAPI> {
  static get relationshipName() { return 'ConstraintHasChildConstraints'; }
  static readonly originSchema = ConstraintWriteAPISchema;
  static readonly destSchema = ConstraintWriteAPISchema;
  static readonly originModelNames = ['Constraint'] as const;
  static readonly destModelNames = ['Constraint'] as const;
  static get origin_property() { return 'child_constraints'; }
  static get dest_property() { return 'parent_constraint'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// ContainsAction: LogicalPart | Action.actions -> Action.parent
export class ContainsAction extends Relationship<LogicalPartWriteAPI | ActionWriteAPI, ActionWriteAPI> {
  static get relationshipName() { return 'ContainsAction'; }
  static readonly originSchema = undefined;
  static readonly destSchema = ActionWriteAPISchema;
  static readonly originModelNames = ['LogicalPart', 'Action'] as const;
  static readonly destModelNames = ['Action'] as const;
  static get origin_property() { return 'actions'; }
  static get dest_property() { return 'parent'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ContainsLogicalPart: LogicalPart.children -> LogicalPart.parent
export class ContainsLogicalPart extends Relationship<LogicalPartWriteAPI, LogicalPartWriteAPI> {
  static get relationshipName() { return 'ContainsLogicalPart'; }
  static readonly originSchema = LogicalPartWriteAPISchema;
  static readonly destSchema = LogicalPartWriteAPISchema;
  static readonly originModelNames = ['LogicalPart'] as const;
  static readonly destModelNames = ['LogicalPart'] as const;
  static get origin_property() { return 'children'; }
  static get dest_property() { return 'parent'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// ContainsPackage: Workspace.packages -> MBSE_Package.workspace
export class ContainsPackage extends Relationship<WorkspaceWriteAPI, MBSE_PackageWriteAPI> {
  static get relationshipName() { return 'ContainsPackage'; }
  static readonly originSchema = WorkspaceWriteAPISchema;
  static readonly destSchema = MBSE_PackageWriteAPISchema;
  static readonly originModelNames = ['Workspace'] as const;
  static readonly destModelNames = ['MBSE_Package'] as const;
  static get origin_property() { return 'packages'; }
  static get dest_property() { return 'workspace'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

export interface ContainsPhysicalPartProperties {
  quantity?: number;
  attachment?: AttachmentResolution;
}

// ContainsPhysicalPart: Project | PhysicalPart.physical_parts -> PhysicalPart.parent
export class ContainsPhysicalPart extends Relationship<ProjectWriteAPI | PhysicalPartWriteAPI, PhysicalPartWriteAPI> {
  static get relationshipName() { return 'ContainsPhysicalPart'; }
  static readonly originSchema = undefined;
  static readonly destSchema = PhysicalPartWriteAPISchema;
  static readonly originModelNames = ['Project', 'PhysicalPart'] as const;
  static readonly destModelNames = ['PhysicalPart'] as const;
  static get origin_property() { return 'physical_parts'; }
  static get dest_property() { return 'parent'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = true as const;
  static readonly edgeProperties = {
    quantity: { type: 'number', optional: true, default: 1 },
    attachment: { type: 'AttachmentResolution', optional: true, default: 'AttachmentResolution.TBD' }
  } as const;
}

// ContainsSoftwarePart: Project | SoftwarePart.software_parts -> SoftwarePart.parent
export class ContainsSoftwarePart extends Relationship<ProjectWriteAPI | SoftwarePartWriteAPI, SoftwarePartWriteAPI> {
  static get relationshipName() { return 'ContainsSoftwarePart'; }
  static readonly originSchema = undefined;
  static readonly destSchema = SoftwarePartWriteAPISchema;
  static readonly originModelNames = ['Project', 'SoftwarePart'] as const;
  static readonly destModelNames = ['SoftwarePart'] as const;
  static get origin_property() { return 'software_parts'; }
  static get dest_property() { return 'parent'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ContributesTo: ThreadTask.thread -> Thread.chat_tasks
export class ContributesTo extends Relationship<ThreadTaskWriteAPI, ThreadWriteAPI> {
  static get relationshipName() { return 'ContributesTo'; }
  static readonly originSchema = ThreadTaskWriteAPISchema;
  static readonly destSchema = ThreadWriteAPISchema;
  static readonly originModelNames = ['ThreadTask'] as const;
  static readonly destModelNames = ['Thread'] as const;
  static get origin_property() { return 'thread'; }
  static get dest_property() { return 'chat_tasks'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// CreatedBy: Step | Thread | ModelRequest.created_by -> User.createdItems
export class CreatedBy extends Relationship<StepWriteAPI | ThreadWriteAPI | ModelRequestWriteAPI, UserWriteAPI> {
  static get relationshipName() { return 'CreatedBy'; }
  static readonly originSchema = undefined;
  static readonly destSchema = UserWriteAPISchema;
  static readonly originModelNames = ['Step', 'Thread', 'ModelRequest'] as const;
  static readonly destModelNames = ['User'] as const;
  static get origin_property() { return 'created_by'; }
  static get dest_property() { return 'createdItems'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

export interface CurrentTaskAttachedToProperties {
  attached_at?: string | null;
}

// CurrentTaskAttachedTo: Task.currently_attached_to -> PDMProduct | Project.current_tasks
export class CurrentTaskAttachedTo extends Relationship<TaskWriteAPI, PDMProductWriteAPI | ProjectWriteAPI> {
  static get relationshipName() { return 'CurrentTaskAttachedTo'; }
  static readonly originSchema = TaskWriteAPISchema;
  static readonly destSchema = undefined;
  static readonly originModelNames = ['Task'] as const;
  static readonly destModelNames = ['PDMProduct', 'Project'] as const;
  static get origin_property() { return 'currently_attached_to'; }
  static get dest_property() { return 'current_tasks'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = true as const;
  static readonly edgeProperties = {
    attached_at: { type: 'string | null', optional: true, default: undefined }
  } as const;
}

// Derivation: RequirementDefinition.derived_requirements -> RequirementDefinition.source_requirement
export class Derivation extends Relationship<RequirementDefinitionWriteAPI, RequirementDefinitionWriteAPI> {
  static get relationshipName() { return 'Derivation'; }
  static readonly originSchema = RequirementDefinitionWriteAPISchema;
  static readonly destSchema = RequirementDefinitionWriteAPISchema;
  static readonly originModelNames = ['RequirementDefinition'] as const;
  static readonly destModelNames = ['RequirementDefinition'] as const;
  static get origin_property() { return 'derived_requirements'; }
  static get dest_property() { return 'source_requirement'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// DerivedFromUnit: SysMLUnit.base_unit -> SysMLUnit.derived_units
export class DerivedFromUnit extends Relationship<SysMLUnitWriteAPI, SysMLUnitWriteAPI> {
  static get relationshipName() { return 'DerivedFromUnit'; }
  static readonly originSchema = SysMLUnitWriteAPISchema;
  static readonly destSchema = SysMLUnitWriteAPISchema;
  static readonly originModelNames = ['SysMLUnit'] as const;
  static readonly destModelNames = ['SysMLUnit'] as const;
  static get origin_property() { return 'base_unit'; }
  static get dest_property() { return 'derived_units'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// DerivedValueOfAttribute: DerivedValue.attribute -> Attribute.unknown
export class DerivedValueOfAttribute extends Relationship<DerivedValueWriteAPI, AttributeWriteAPI> {
  static get relationshipName() { return 'DerivedValueOfAttribute'; }
  static readonly originSchema = DerivedValueWriteAPISchema;
  static readonly destSchema = AttributeWriteAPISchema;
  static readonly originModelNames = ['DerivedValue'] as const;
  static readonly destModelNames = ['Attribute'] as const;
  static get origin_property() { return 'attribute'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// DerivedValueOfExpression: DerivedValue.expression -> DerivedExpression.result
export class DerivedValueOfExpression extends Relationship<DerivedValueWriteAPI, DerivedExpressionWriteAPI> {
  static get relationshipName() { return 'DerivedValueOfExpression'; }
  static readonly originSchema = DerivedValueWriteAPISchema;
  static readonly destSchema = DerivedExpressionWriteAPISchema;
  static readonly originModelNames = ['DerivedValue'] as const;
  static readonly destModelNames = ['DerivedExpression'] as const;
  static get origin_property() { return 'expression'; }
  static get dest_property() { return 'result'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// DesignsPackage: Thread.dev_package -> MBSE_Package.dev_threads
export class DesignsPackage extends Relationship<ThreadWriteAPI, MBSE_PackageWriteAPI> {
  static get relationshipName() { return 'DesignsPackage'; }
  static readonly originSchema = ThreadWriteAPISchema;
  static readonly destSchema = MBSE_PackageWriteAPISchema;
  static readonly originModelNames = ['Thread'] as const;
  static readonly destModelNames = ['MBSE_Package'] as const;
  static get origin_property() { return 'dev_package'; }
  static get dest_property() { return 'dev_threads'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// EditsNode: LLMTask.edits_nodes -> ScopedNode.unknown
export class EditsNode extends Relationship<LLMTaskWriteAPI, ScopedNodeWriteAPI> {
  static get relationshipName() { return 'EditsNode'; }
  static readonly originSchema = LLMTaskWriteAPISchema;
  static readonly destSchema = ScopedNodeWriteAPISchema;
  static readonly originModelNames = ['LLMTask'] as const;
  static readonly destModelNames = ['ScopedNode'] as const;
  static get origin_property() { return 'edits_nodes'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ExpandsNode: IntrinsicExpansionTask.expands_nodes -> ScopedNode.unknown
export class ExpandsNode extends Relationship<IntrinsicExpansionTaskWriteAPI, ScopedNodeWriteAPI> {
  static get relationshipName() { return 'ExpandsNode'; }
  static readonly originSchema = IntrinsicExpansionTaskWriteAPISchema;
  static readonly destSchema = ScopedNodeWriteAPISchema;
  static readonly originModelNames = ['IntrinsicExpansionTask'] as const;
  static readonly destModelNames = ['ScopedNode'] as const;
  static get origin_property() { return 'expands_nodes'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ExtractsNode: EntityExtractionTask.extracts_nodes -> ScopedNode.unknown
export class ExtractsNode extends Relationship<EntityExtractionTaskWriteAPI, ScopedNodeWriteAPI> {
  static get relationshipName() { return 'ExtractsNode'; }
  static readonly originSchema = EntityExtractionTaskWriteAPISchema;
  static readonly destSchema = ScopedNodeWriteAPISchema;
  static readonly originModelNames = ['EntityExtractionTask'] as const;
  static readonly destModelNames = ['ScopedNode'] as const;
  static get origin_property() { return 'extracts_nodes'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// FlowConnection: ActionDefinition.output_flows_to -> ActionDefinition.input_flows_from
export class FlowConnection extends Relationship<ActionDefinitionWriteAPI, ActionDefinitionWriteAPI> {
  static get relationshipName() { return 'FlowConnection'; }
  static readonly originSchema = ActionDefinitionWriteAPISchema;
  static readonly destSchema = ActionDefinitionWriteAPISchema;
  static readonly originModelNames = ['ActionDefinition'] as const;
  static readonly destModelNames = ['ActionDefinition'] as const;
  static get origin_property() { return 'output_flows_to'; }
  static get dest_property() { return 'input_flows_from'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

export interface FormalisesProperties {
  role?: ConstraintRole;
}

// Formalises: Constraint.formalises -> Requirement.constrained_by
export class Formalises extends Relationship<ConstraintWriteAPI, RequirementWriteAPI> {
  static get relationshipName() { return 'Formalises'; }
  static readonly originSchema = ConstraintWriteAPISchema;
  static readonly destSchema = RequirementWriteAPISchema;
  static readonly originModelNames = ['Constraint'] as const;
  static readonly destModelNames = ['Requirement'] as const;
  static get origin_property() { return 'formalises'; }
  static get dest_property() { return 'constrained_by'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = true as const;
  static readonly edgeProperties = {
    role: { type: 'ConstraintRole', optional: true, default: 'ConstraintRole.REQUIRE' }
  } as const;
}

// FramesConcern: Requirement.frames_concerns -> Concern.framed_by
export class FramesConcern extends Relationship<RequirementWriteAPI, ConcernWriteAPI> {
  static get relationshipName() { return 'FramesConcern'; }
  static readonly originSchema = RequirementWriteAPISchema;
  static readonly destSchema = ConcernWriteAPISchema;
  static readonly originModelNames = ['Requirement'] as const;
  static readonly destModelNames = ['Concern'] as const;
  static get origin_property() { return 'frames_concerns'; }
  static get dest_property() { return 'framed_by'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// GeneratesNode: DanglingPortResolutionTask | RequirementSatisfactionTask.generates_nodes -> ScopedNode.unknown
export class GeneratesNode extends Relationship<DanglingPortResolutionTaskWriteAPI | RequirementSatisfactionTaskWriteAPI, ScopedNodeWriteAPI> {
  static get relationshipName() { return 'GeneratesNode'; }
  static readonly originSchema = undefined;
  static readonly destSchema = ScopedNodeWriteAPISchema;
  static readonly originModelNames = ['DanglingPortResolutionTask', 'RequirementSatisfactionTask'] as const;
  static readonly destModelNames = ['ScopedNode'] as const;
  static get origin_property() { return 'generates_nodes'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// GitHubRepoOfOrganisation: GitHubRepo.organisation -> Organisation.github_repos
export class GitHubRepoOfOrganisation extends Relationship<GitHubRepoWriteAPI, OrganisationWriteAPI> {
  static get relationshipName() { return 'GitHubRepoOfOrganisation'; }
  static readonly originSchema = GitHubRepoWriteAPISchema;
  static readonly destSchema = OrganisationWriteAPISchema;
  static readonly originModelNames = ['GitHubRepo'] as const;
  static readonly destModelNames = ['Organisation'] as const;
  static get origin_property() { return 'organisation'; }
  static get dest_property() { return 'github_repos'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// GlossaryTermInWorkspace: GlossaryTerm.workspace -> Workspace.unknown
export class GlossaryTermInWorkspace extends Relationship<GlossaryTermWriteAPI, WorkspaceWriteAPI> {
  static get relationshipName() { return 'GlossaryTermInWorkspace'; }
  static readonly originSchema = GlossaryTermWriteAPISchema;
  static readonly destSchema = WorkspaceWriteAPISchema;
  static readonly originModelNames = ['GlossaryTerm'] as const;
  static readonly destModelNames = ['Workspace'] as const;
  static get origin_property() { return 'workspace'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// GroupAt: Group.scope -> SecurityScope.groups
export class GroupAt extends Relationship<GroupWriteAPI, SecurityScopeWriteAPI> {
  static get relationshipName() { return 'GroupAt'; }
  static readonly originSchema = GroupWriteAPISchema;
  static readonly destSchema = SecurityScopeWriteAPISchema;
  static readonly originModelNames = ['Group'] as const;
  static readonly destModelNames = ['SecurityScope'] as const;
  static get origin_property() { return 'scope'; }
  static get dest_property() { return 'groups'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasActions: PDMProduct.actions -> PDMAction.product
export class HasActions extends Relationship<PDMProductWriteAPI, PDMActionWriteAPI> {
  static get relationshipName() { return 'HasActions'; }
  static readonly originSchema = PDMProductWriteAPISchema;
  static readonly destSchema = PDMActionWriteAPISchema;
  static readonly originModelNames = ['PDMProduct'] as const;
  static readonly destModelNames = ['PDMAction'] as const;
  static get origin_property() { return 'actions'; }
  static get dest_property() { return 'product'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// HasAnswer: Question.answer -> Answer.question
export class HasAnswer extends Relationship<QuestionWriteAPI, AnswerWriteAPI> {
  static get relationshipName() { return 'HasAnswer'; }
  static readonly originSchema = QuestionWriteAPISchema;
  static readonly destSchema = AnswerWriteAPISchema;
  static readonly originModelNames = ['Question'] as const;
  static readonly destModelNames = ['Answer'] as const;
  static get origin_property() { return 'answer'; }
  static get dest_property() { return 'question'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasAttribute: RFLPElement.attributes -> Attribute.unknown
export class HasAttribute extends Relationship<RFLPElementWriteAPI, AttributeWriteAPI> {
  static get relationshipName() { return 'HasAttribute'; }
  static readonly originSchema = RFLPElementWriteAPISchema;
  static readonly destSchema = AttributeWriteAPISchema;
  static readonly originModelNames = ['RFLPElement'] as const;
  static readonly destModelNames = ['Attribute'] as const;
  static get origin_property() { return 'attributes'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasAttributeValue: RFLPElement.attribute_values -> AttributeValue.owner
export class HasAttributeValue extends Relationship<RFLPElementWriteAPI, AttributeValueWriteAPI> {
  static get relationshipName() { return 'HasAttributeValue'; }
  static readonly originSchema = RFLPElementWriteAPISchema;
  static readonly destSchema = AttributeValueWriteAPISchema;
  static readonly originModelNames = ['RFLPElement'] as const;
  static readonly destModelNames = ['AttributeValue'] as const;
  static get origin_property() { return 'attribute_values'; }
  static get dest_property() { return 'owner'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasConstraints: SysMLConstraint.unknown -> AttributeDefinition.unknown
export class HasConstraints extends Relationship<SysMLConstraintWriteAPI, AttributeDefinitionWriteAPI> {
  static get relationshipName() { return 'HasConstraints'; }
  static readonly originSchema = SysMLConstraintWriteAPISchema;
  static readonly destSchema = AttributeDefinitionWriteAPISchema;
  static readonly originModelNames = ['SysMLConstraint'] as const;
  static readonly destModelNames = ['AttributeDefinition'] as const;
  static get origin_property() { return 'unknown'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasContentObject: ToolCallResponse.content_objects -> ScopedNode.unknown
export class HasContentObject extends Relationship<ToolCallResponseWriteAPI, ScopedNodeWriteAPI> {
  static get relationshipName() { return 'HasContentObject'; }
  static readonly originSchema = ToolCallResponseWriteAPISchema;
  static readonly destSchema = ScopedNodeWriteAPISchema;
  static readonly originModelNames = ['ToolCallResponse'] as const;
  static readonly destModelNames = ['ScopedNode'] as const;
  static get origin_property() { return 'content_objects'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasContext: Step | Thread.context_items -> ScopedNode.unknown
export class HasContext extends Relationship<StepWriteAPI | ThreadWriteAPI, ScopedNodeWriteAPI> {
  static get relationshipName() { return 'HasContext'; }
  static readonly originSchema = undefined;
  static readonly destSchema = ScopedNodeWriteAPISchema;
  static readonly originModelNames = ['Step', 'Thread'] as const;
  static readonly destModelNames = ['ScopedNode'] as const;
  static get origin_property() { return 'context_items'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasDerivedValue: RFLPElement.derived_values -> DerivedValue.owner
export class HasDerivedValue extends Relationship<RFLPElementWriteAPI, DerivedValueWriteAPI> {
  static get relationshipName() { return 'HasDerivedValue'; }
  static readonly originSchema = RFLPElementWriteAPISchema;
  static readonly destSchema = DerivedValueWriteAPISchema;
  static readonly originModelNames = ['RFLPElement'] as const;
  static readonly destModelNames = ['DerivedValue'] as const;
  static get origin_property() { return 'derived_values'; }
  static get dest_property() { return 'owner'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasExpression: SysMLExpression.unknown -> AttributeDefinition.unknown
export class HasExpression extends Relationship<SysMLExpressionWriteAPI, AttributeDefinitionWriteAPI> {
  static get relationshipName() { return 'HasExpression'; }
  static readonly originSchema = SysMLExpressionWriteAPISchema;
  static readonly destSchema = AttributeDefinitionWriteAPISchema;
  static readonly originModelNames = ['SysMLExpression'] as const;
  static readonly destModelNames = ['AttributeDefinition'] as const;
  static get origin_property() { return 'unknown'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasExpressionInputs: SysMLExpression.unknown -> AttributeDefinition.unknown
export class HasExpressionInputs extends Relationship<SysMLExpressionWriteAPI, AttributeDefinitionWriteAPI> {
  static get relationshipName() { return 'HasExpressionInputs'; }
  static readonly originSchema = SysMLExpressionWriteAPISchema;
  static readonly destSchema = AttributeDefinitionWriteAPISchema;
  static readonly originModelNames = ['SysMLExpression'] as const;
  static readonly destModelNames = ['AttributeDefinition'] as const;
  static get origin_property() { return 'unknown'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasInterfacePort: LogicalPart | Part.interface_ports -> InterfacePort.owner
export class HasInterfacePort extends Relationship<LogicalPartWriteAPI | PartWriteAPI, InterfacePortWriteAPI> {
  static get relationshipName() { return 'HasInterfacePort'; }
  static readonly originSchema = undefined;
  static readonly destSchema = InterfacePortWriteAPISchema;
  static readonly originModelNames = ['LogicalPart', 'Part'] as const;
  static readonly destModelNames = ['InterfacePort'] as const;
  static get origin_property() { return 'interface_ports'; }
  static get dest_property() { return 'owner'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasMembers: SysMLNamespace.members -> SysMLElement.member_namespace
export class HasMembers extends Relationship<SysMLNamespaceWriteAPI, SysMLElementWriteAPI> {
  static get relationshipName() { return 'HasMembers'; }
  static readonly originSchema = SysMLNamespaceWriteAPISchema;
  static readonly destSchema = SysMLElementWriteAPISchema;
  static readonly originModelNames = ['SysMLNamespace'] as const;
  static readonly destModelNames = ['SysMLElement'] as const;
  static get origin_property() { return 'members'; }
  static get dest_property() { return 'member_namespace'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasModelRequestResponse: ModelRequest.model_response -> ModelResponse.model_request
export class HasModelRequestResponse extends Relationship<ModelRequestWriteAPI, ModelResponseWriteAPI> {
  static get relationshipName() { return 'HasModelRequestResponse'; }
  static readonly originSchema = ModelRequestWriteAPISchema;
  static readonly destSchema = ModelResponseWriteAPISchema;
  static readonly originModelNames = ['ModelRequest'] as const;
  static readonly destModelNames = ['ModelResponse'] as const;
  static get origin_property() { return 'model_response'; }
  static get dest_property() { return 'model_request'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasModelRequests: Step.model_requests -> ModelRequest.step
export class HasModelRequests extends Relationship<StepWriteAPI, ModelRequestWriteAPI> {
  static get relationshipName() { return 'HasModelRequests'; }
  static readonly originSchema = StepWriteAPISchema;
  static readonly destSchema = ModelRequestWriteAPISchema;
  static readonly originModelNames = ['Step'] as const;
  static readonly destModelNames = ['ModelRequest'] as const;
  static get origin_property() { return 'model_requests'; }
  static get dest_property() { return 'step'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasPorts: PDMPart.ports -> PDMPort.part
export class HasPorts extends Relationship<PDMPartWriteAPI, PDMPortWriteAPI> {
  static get relationshipName() { return 'HasPorts'; }
  static readonly originSchema = PDMPartWriteAPISchema;
  static readonly destSchema = PDMPortWriteAPISchema;
  static readonly originModelNames = ['PDMPart'] as const;
  static readonly destModelNames = ['PDMPort'] as const;
  static get origin_property() { return 'ports'; }
  static get dest_property() { return 'part'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// HasProduct: Workspace.products -> PDMProduct.workspace
export class HasProduct extends Relationship<WorkspaceWriteAPI, PDMProductWriteAPI> {
  static get relationshipName() { return 'HasProduct'; }
  static readonly originSchema = WorkspaceWriteAPISchema;
  static readonly destSchema = PDMProductWriteAPISchema;
  static readonly originModelNames = ['Workspace'] as const;
  static readonly destModelNames = ['PDMProduct'] as const;
  static get origin_property() { return 'products'; }
  static get dest_property() { return 'workspace'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasQuestionnaire: ToolCallPart.questionnaire -> Questionnaire.tool_call_part
export class HasQuestionnaire extends Relationship<ToolCallPartWriteAPI, QuestionnaireWriteAPI> {
  static get relationshipName() { return 'HasQuestionnaire'; }
  static readonly originSchema = ToolCallPartWriteAPISchema;
  static readonly destSchema = QuestionnaireWriteAPISchema;
  static readonly originModelNames = ['ToolCallPart'] as const;
  static readonly destModelNames = ['Questionnaire'] as const;
  static get origin_property() { return 'questionnaire'; }
  static get dest_property() { return 'tool_call_part'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasQuestions: Questionnaire.questions -> Question.questionnaire
export class HasQuestions extends Relationship<QuestionnaireWriteAPI, QuestionWriteAPI> {
  static get relationshipName() { return 'HasQuestions'; }
  static readonly originSchema = QuestionnaireWriteAPISchema;
  static readonly destSchema = QuestionWriteAPISchema;
  static readonly originModelNames = ['Questionnaire'] as const;
  static readonly destModelNames = ['Question'] as const;
  static get origin_property() { return 'questions'; }
  static get dest_property() { return 'questionnaire'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasRFLPProject: Workspace.rflp_projects -> Project.workspace
export class HasRFLPProject extends Relationship<WorkspaceWriteAPI, ProjectWriteAPI> {
  static get relationshipName() { return 'HasRFLPProject'; }
  static readonly originSchema = WorkspaceWriteAPISchema;
  static readonly destSchema = ProjectWriteAPISchema;
  static readonly originModelNames = ['Workspace'] as const;
  static readonly destModelNames = ['Project'] as const;
  static get origin_property() { return 'rflp_projects'; }
  static get dest_property() { return 'workspace'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasRequirement: LogicalPart | Part | Requirement.requirements -> Requirement.container
export class HasRequirement extends Relationship<LogicalPartWriteAPI | PartWriteAPI | RequirementWriteAPI, RequirementWriteAPI> {
  static get relationshipName() { return 'HasRequirement'; }
  static readonly originSchema = undefined;
  static readonly destSchema = RequirementWriteAPISchema;
  static readonly originModelNames = ['LogicalPart', 'Part', 'Requirement'] as const;
  static readonly destModelNames = ['Requirement'] as const;
  static get origin_property() { return 'requirements'; }
  static get dest_property() { return 'container'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasRequirements: PDMProduct | PDMAction.requirements -> PDMRequirement.owner
export class HasRequirements extends Relationship<PDMProductWriteAPI | PDMActionWriteAPI, PDMRequirementWriteAPI> {
  static get relationshipName() { return 'HasRequirements'; }
  static readonly originSchema = undefined;
  static readonly destSchema = PDMRequirementWriteAPISchema;
  static readonly originModelNames = ['PDMProduct', 'PDMAction'] as const;
  static readonly destModelNames = ['PDMRequirement'] as const;
  static get origin_property() { return 'requirements'; }
  static get dest_property() { return 'owner'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// HasResponse: ToolCallPart.response -> ToolCallResponse.tool_call
export class HasResponse extends Relationship<ToolCallPartWriteAPI, ToolCallResponseWriteAPI> {
  static get relationshipName() { return 'HasResponse'; }
  static readonly originSchema = ToolCallPartWriteAPISchema;
  static readonly destSchema = ToolCallResponseWriteAPISchema;
  static readonly originModelNames = ['ToolCallPart'] as const;
  static readonly destModelNames = ['ToolCallResponse'] as const;
  static get origin_property() { return 'response'; }
  static get dest_property() { return 'tool_call'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasRootPart: PDMProduct.root_part -> PDMPart.product
export class HasRootPart extends Relationship<PDMProductWriteAPI, PDMPartWriteAPI> {
  static get relationshipName() { return 'HasRootPart'; }
  static readonly originSchema = PDMProductWriteAPISchema;
  static readonly destSchema = PDMPartWriteAPISchema;
  static readonly originModelNames = ['PDMProduct'] as const;
  static readonly destModelNames = ['PDMPart'] as const;
  static get origin_property() { return 'root_part'; }
  static get dest_property() { return 'product'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// HasSource: Requirement.sources -> SourceDocument | Standard | StakeholderNeed.cited_by_requirements
export class HasSource extends Relationship<RequirementWriteAPI, SourceDocumentWriteAPI | StandardWriteAPI | StakeholderNeedWriteAPI> {
  static get relationshipName() { return 'HasSource'; }
  static readonly originSchema = RequirementWriteAPISchema;
  static readonly destSchema = undefined;
  static readonly originModelNames = ['Requirement'] as const;
  static readonly destModelNames = ['SourceDocument', 'Standard', 'StakeholderNeed'] as const;
  static get origin_property() { return 'sources'; }
  static get dest_property() { return 'cited_by_requirements'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasStakeholderNeed: LogicalPart.stakeholder_needs -> StakeholderNeed.container
export class HasStakeholderNeed extends Relationship<LogicalPartWriteAPI, StakeholderNeedWriteAPI> {
  static get relationshipName() { return 'HasStakeholderNeed'; }
  static readonly originSchema = LogicalPartWriteAPISchema;
  static readonly destSchema = StakeholderNeedWriteAPISchema;
  static readonly originModelNames = ['LogicalPart'] as const;
  static readonly destModelNames = ['StakeholderNeed'] as const;
  static get origin_property() { return 'stakeholder_needs'; }
  static get dest_property() { return 'container'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasSteps: Thread.steps -> Step.thread
export class HasSteps extends Relationship<ThreadWriteAPI, StepWriteAPI> {
  static get relationshipName() { return 'HasSteps'; }
  static readonly originSchema = ThreadWriteAPISchema;
  static readonly destSchema = StepWriteAPISchema;
  static readonly originModelNames = ['Thread'] as const;
  static readonly destModelNames = ['Step'] as const;
  static get origin_property() { return 'steps'; }
  static get dest_property() { return 'thread'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// HasSubRequirements: RequirementDefinition.sub_requirements -> RequirementDefinition.parent_requirement
export class HasSubRequirements extends Relationship<RequirementDefinitionWriteAPI, RequirementDefinitionWriteAPI> {
  static get relationshipName() { return 'HasSubRequirements'; }
  static readonly originSchema = RequirementDefinitionWriteAPISchema;
  static readonly destSchema = RequirementDefinitionWriteAPISchema;
  static readonly originModelNames = ['RequirementDefinition'] as const;
  static readonly destModelNames = ['RequirementDefinition'] as const;
  static get origin_property() { return 'sub_requirements'; }
  static get dest_property() { return 'parent_requirement'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// HasSupplyChainCriteria: PDMProduct.supply_chain -> PDMSupplyChainCriteria.product
export class HasSupplyChainCriteria extends Relationship<PDMProductWriteAPI, PDMSupplyChainCriteriaWriteAPI> {
  static get relationshipName() { return 'HasSupplyChainCriteria'; }
  static readonly originSchema = PDMProductWriteAPISchema;
  static readonly destSchema = PDMSupplyChainCriteriaWriteAPISchema;
  static readonly originModelNames = ['PDMProduct'] as const;
  static readonly destModelNames = ['PDMSupplyChainCriteria'] as const;
  static get origin_property() { return 'supply_chain'; }
  static get dest_property() { return 'product'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// HasThread: Task | LLMTask.thread -> Thread.task
export class HasThread extends Relationship<TaskWriteAPI | LLMTaskWriteAPI, ThreadWriteAPI> {
  static get relationshipName() { return 'HasThread'; }
  static readonly originSchema = undefined;
  static readonly destSchema = ThreadWriteAPISchema;
  static readonly originModelNames = ['Task', 'LLMTask'] as const;
  static readonly destModelNames = ['Thread'] as const;
  static get origin_property() { return 'thread'; }
  static get dest_property() { return 'task'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// HasThreads: Workspace.threads -> Thread.workspace
export class HasThreads extends Relationship<WorkspaceWriteAPI, ThreadWriteAPI> {
  static get relationshipName() { return 'HasThreads'; }
  static readonly originSchema = WorkspaceWriteAPISchema;
  static readonly destSchema = ThreadWriteAPISchema;
  static readonly originModelNames = ['Workspace'] as const;
  static readonly destModelNames = ['Thread'] as const;
  static get origin_property() { return 'threads'; }
  static get dest_property() { return 'workspace'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// InviteTo: Invite.scope -> SecurityScope.unknown
export class InviteTo extends Relationship<InviteWriteAPI, SecurityScopeWriteAPI> {
  static get relationshipName() { return 'InviteTo'; }
  static readonly originSchema = InviteWriteAPISchema;
  static readonly destSchema = SecurityScopeWriteAPISchema;
  static readonly originModelNames = ['Invite'] as const;
  static readonly destModelNames = ['SecurityScope'] as const;
  static get origin_property() { return 'scope'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// IsPart: ModelResponse.parts -> ResponsePart.model_response
export class IsPart extends Relationship<ModelResponseWriteAPI, ResponsePartWriteAPI> {
  static get relationshipName() { return 'IsPart'; }
  static readonly originSchema = ModelResponseWriteAPISchema;
  static readonly destSchema = ResponsePartWriteAPISchema;
  static readonly originModelNames = ['ModelResponse'] as const;
  static readonly destModelNames = ['ResponsePart'] as const;
  static get origin_property() { return 'parts'; }
  static get dest_property() { return 'model_response'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// IslandHoldsPin: IslandRoot.island_pins -> IslandPin.holder
export class IslandHoldsPin extends Relationship<IslandRootWriteAPI, IslandPinWriteAPI> {
  static get relationshipName() { return 'IslandHoldsPin'; }
  static readonly originSchema = IslandRootWriteAPISchema;
  static readonly destSchema = IslandPinWriteAPISchema;
  static readonly originModelNames = ['IslandRoot'] as const;
  static readonly destModelNames = ['IslandPin'] as const;
  static get origin_property() { return 'island_pins'; }
  static get dest_property() { return 'holder'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// ItemFlowMeasuredIn: ItemFlow.unit -> Unit.unknown
export class ItemFlowMeasuredIn extends Relationship<ItemFlowWriteAPI, UnitWriteAPI> {
  static get relationshipName() { return 'ItemFlowMeasuredIn'; }
  static readonly originSchema = ItemFlowWriteAPISchema;
  static readonly destSchema = UnitWriteAPISchema;
  static readonly originModelNames = ['ItemFlow'] as const;
  static readonly destModelNames = ['Unit'] as const;
  static get origin_property() { return 'unit'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ItemFlowRealizedBy: ItemFlow.realized_by -> Connection.realizes_item_flows
export class ItemFlowRealizedBy extends Relationship<ItemFlowWriteAPI, ConnectionWriteAPI> {
  static get relationshipName() { return 'ItemFlowRealizedBy'; }
  static readonly originSchema = ItemFlowWriteAPISchema;
  static readonly destSchema = ConnectionWriteAPISchema;
  static readonly originModelNames = ['ItemFlow'] as const;
  static readonly destModelNames = ['Connection'] as const;
  static get origin_property() { return 'realized_by'; }
  static get dest_property() { return 'realizes_item_flows'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ItemFlowSourceParameter: ItemFlow.source_parameter -> ActionOutputParameter.outgoing_flows
export class ItemFlowSourceParameter extends Relationship<ItemFlowWriteAPI, ActionOutputParameterWriteAPI> {
  static get relationshipName() { return 'ItemFlowSourceParameter'; }
  static readonly originSchema = ItemFlowWriteAPISchema;
  static readonly destSchema = ActionOutputParameterWriteAPISchema;
  static readonly originModelNames = ['ItemFlow'] as const;
  static readonly destModelNames = ['ActionOutputParameter'] as const;
  static get origin_property() { return 'source_parameter'; }
  static get dest_property() { return 'outgoing_flows'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ItemFlowTargetParameter: ItemFlow.target_parameter -> ActionInputParameter.incoming_flows
export class ItemFlowTargetParameter extends Relationship<ItemFlowWriteAPI, ActionInputParameterWriteAPI> {
  static get relationshipName() { return 'ItemFlowTargetParameter'; }
  static readonly originSchema = ItemFlowWriteAPISchema;
  static readonly destSchema = ActionInputParameterWriteAPISchema;
  static readonly originModelNames = ['ItemFlow'] as const;
  static readonly destModelNames = ['ActionInputParameter'] as const;
  static get origin_property() { return 'target_parameter'; }
  static get dest_property() { return 'incoming_flows'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ItemFlowTypedBy: ItemFlow.item -> Item.unknown
export class ItemFlowTypedBy extends Relationship<ItemFlowWriteAPI, ItemWriteAPI> {
  static get relationshipName() { return 'ItemFlowTypedBy'; }
  static readonly originSchema = ItemFlowWriteAPISchema;
  static readonly destSchema = ItemWriteAPISchema;
  static readonly originModelNames = ['ItemFlow'] as const;
  static readonly destModelNames = ['Item'] as const;
  static get origin_property() { return 'item'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ItemHasCanonicalUnit: Item.canonical_unit -> Unit.unknown
export class ItemHasCanonicalUnit extends Relationship<ItemWriteAPI, UnitWriteAPI> {
  static get relationshipName() { return 'ItemHasCanonicalUnit'; }
  static readonly originSchema = ItemWriteAPISchema;
  static readonly destSchema = UnitWriteAPISchema;
  static readonly originModelNames = ['Item'] as const;
  static readonly destModelNames = ['Unit'] as const;
  static get origin_property() { return 'canonical_unit'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ItemInWorkspace: Item.workspace -> Workspace.unknown
export class ItemInWorkspace extends Relationship<ItemWriteAPI, WorkspaceWriteAPI> {
  static get relationshipName() { return 'ItemInWorkspace'; }
  static readonly originSchema = ItemWriteAPISchema;
  static readonly destSchema = WorkspaceWriteAPISchema;
  static readonly originModelNames = ['Item'] as const;
  static readonly destModelNames = ['Workspace'] as const;
  static get origin_property() { return 'workspace'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// LPBindsBehavioralPort: LogicalPart.bound_behavioral_ports -> PhysicsPort | ControlPort.bound_to
export class LPBindsBehavioralPort extends Relationship<LogicalPartWriteAPI, PhysicsPortWriteAPI | ControlPortWriteAPI> {
  static get relationshipName() { return 'LPBindsBehavioralPort'; }
  static readonly originSchema = LogicalPartWriteAPISchema;
  static readonly destSchema = undefined;
  static readonly originModelNames = ['LogicalPart'] as const;
  static readonly destModelNames = ['PhysicsPort', 'ControlPort'] as const;
  static get origin_property() { return 'bound_behavioral_ports'; }
  static get dest_property() { return 'bound_to'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// LPHasBehavioralPort: LogicalPart.behavioral_ports -> PhysicsPort | ControlPort.owner
export class LPHasBehavioralPort extends Relationship<LogicalPartWriteAPI, PhysicsPortWriteAPI | ControlPortWriteAPI> {
  static get relationshipName() { return 'LPHasBehavioralPort'; }
  static readonly originSchema = LogicalPartWriteAPISchema;
  static readonly destSchema = undefined;
  static readonly originModelNames = ['LogicalPart'] as const;
  static readonly destModelNames = ['PhysicsPort', 'ControlPort'] as const;
  static get origin_property() { return 'behavioral_ports'; }
  static get dest_property() { return 'owner'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MBSE_Allocates: MBSE_Action.parts -> MBSE_Part.allocated_to
export class MBSE_Allocates extends Relationship<MBSE_ActionWriteAPI, MBSE_PartWriteAPI> {
  static get relationshipName() { return 'MBSE_Allocates'; }
  static readonly originSchema = MBSE_ActionWriteAPISchema;
  static readonly destSchema = MBSE_PartWriteAPISchema;
  static readonly originModelNames = ['MBSE_Action'] as const;
  static readonly destModelNames = ['MBSE_Part'] as const;
  static get origin_property() { return 'parts'; }
  static get dest_property() { return 'allocated_to'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MBSE_Attributes: MBSE_Requirement | MBSE_Action | MBSE_Part | MBSE_Port.attributes -> MBSE_Attribute.subjects
export class MBSE_Attributes extends Relationship<MBSE_RequirementWriteAPI | MBSE_ActionWriteAPI | MBSE_PartWriteAPI | MBSE_PortWriteAPI, MBSE_AttributeWriteAPI> {
  static get relationshipName() { return 'MBSE_Attributes'; }
  static readonly originSchema = undefined;
  static readonly destSchema = MBSE_AttributeWriteAPISchema;
  static readonly originModelNames = ['MBSE_Requirement', 'MBSE_Action', 'MBSE_Part', 'MBSE_Port'] as const;
  static readonly destModelNames = ['MBSE_Attribute'] as const;
  static get origin_property() { return 'attributes'; }
  static get dest_property() { return 'subjects'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MBSE_Bind: MBSE_Attribute.binds_to -> MBSE_Attribute.bound_in
export class MBSE_Bind extends Relationship<MBSE_AttributeWriteAPI, MBSE_AttributeWriteAPI> {
  static get relationshipName() { return 'MBSE_Bind'; }
  static readonly originSchema = MBSE_AttributeWriteAPISchema;
  static readonly destSchema = MBSE_AttributeWriteAPISchema;
  static readonly originModelNames = ['MBSE_Attribute'] as const;
  static readonly destModelNames = ['MBSE_Attribute'] as const;
  static get origin_property() { return 'binds_to'; }
  static get dest_property() { return 'bound_in'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MBSE_Delegation: MBSE_Port.delegates_on -> MBSE_Port.delegate_of
export class MBSE_Delegation extends Relationship<MBSE_PortWriteAPI, MBSE_PortWriteAPI> {
  static get relationshipName() { return 'MBSE_Delegation'; }
  static readonly originSchema = MBSE_PortWriteAPISchema;
  static readonly destSchema = MBSE_PortWriteAPISchema;
  static readonly originModelNames = ['MBSE_Port'] as const;
  static readonly destModelNames = ['MBSE_Port'] as const;
  static get origin_property() { return 'delegates_on'; }
  static get dest_property() { return 'delegate_of'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MBSE_Derivation: MBSE_Requirement.derives_on -> MBSE_Requirement.derived_from
export class MBSE_Derivation extends Relationship<MBSE_RequirementWriteAPI, MBSE_RequirementWriteAPI> {
  static get relationshipName() { return 'MBSE_Derivation'; }
  static readonly originSchema = MBSE_RequirementWriteAPISchema;
  static readonly destSchema = MBSE_RequirementWriteAPISchema;
  static readonly originModelNames = ['MBSE_Requirement'] as const;
  static readonly destModelNames = ['MBSE_Requirement'] as const;
  static get origin_property() { return 'derives_on'; }
  static get dest_property() { return 'derived_from'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MBSE_Flows: MBSE_Port.flows_to -> MBSE_Port.flows_from
export class MBSE_Flows extends Relationship<MBSE_PortWriteAPI, MBSE_PortWriteAPI> {
  static get relationshipName() { return 'MBSE_Flows'; }
  static readonly originSchema = MBSE_PortWriteAPISchema;
  static readonly destSchema = MBSE_PortWriteAPISchema;
  static readonly originModelNames = ['MBSE_Port'] as const;
  static readonly destModelNames = ['MBSE_Port'] as const;
  static get origin_property() { return 'flows_to'; }
  static get dest_property() { return 'flows_from'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MBSE_MainFunction: MBSE_Package.main_function -> MBSE_Action.package
export class MBSE_MainFunction extends Relationship<MBSE_PackageWriteAPI, MBSE_ActionWriteAPI> {
  static get relationshipName() { return 'MBSE_MainFunction'; }
  static readonly originSchema = MBSE_PackageWriteAPISchema;
  static readonly destSchema = MBSE_ActionWriteAPISchema;
  static readonly originModelNames = ['MBSE_Package'] as const;
  static readonly destModelNames = ['MBSE_Action'] as const;
  static get origin_property() { return 'main_function'; }
  static get dest_property() { return 'package'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MBSE_Ports: MBSE_Action | MBSE_Part.ports -> MBSE_Port.owner
export class MBSE_Ports extends Relationship<MBSE_ActionWriteAPI | MBSE_PartWriteAPI, MBSE_PortWriteAPI> {
  static get relationshipName() { return 'MBSE_Ports'; }
  static readonly originSchema = undefined;
  static readonly destSchema = MBSE_PortWriteAPISchema;
  static readonly originModelNames = ['MBSE_Action', 'MBSE_Part'] as const;
  static readonly destModelNames = ['MBSE_Port'] as const;
  static get origin_property() { return 'ports'; }
  static get dest_property() { return 'owner'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MBSE_Refinement: MBSE_Requirement.refined_by -> MBSE_Requirement.refinement_of
export class MBSE_Refinement extends Relationship<MBSE_RequirementWriteAPI, MBSE_RequirementWriteAPI> {
  static get relationshipName() { return 'MBSE_Refinement'; }
  static readonly originSchema = MBSE_RequirementWriteAPISchema;
  static readonly destSchema = MBSE_RequirementWriteAPISchema;
  static readonly originModelNames = ['MBSE_Requirement'] as const;
  static readonly destModelNames = ['MBSE_Requirement'] as const;
  static get origin_property() { return 'refined_by'; }
  static get dest_property() { return 'refinement_of'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MBSE_Requirements: MBSE_Package.requirements -> MBSE_Requirement.package
export class MBSE_Requirements extends Relationship<MBSE_PackageWriteAPI, MBSE_RequirementWriteAPI> {
  static get relationshipName() { return 'MBSE_Requirements'; }
  static readonly originSchema = MBSE_PackageWriteAPISchema;
  static readonly destSchema = MBSE_RequirementWriteAPISchema;
  static readonly originModelNames = ['MBSE_Package'] as const;
  static readonly destModelNames = ['MBSE_Requirement'] as const;
  static get origin_property() { return 'requirements'; }
  static get dest_property() { return 'package'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MBSE_RootPart: MBSE_Package.root_part -> MBSE_Part.package
export class MBSE_RootPart extends Relationship<MBSE_PackageWriteAPI, MBSE_PartWriteAPI> {
  static get relationshipName() { return 'MBSE_RootPart'; }
  static readonly originSchema = MBSE_PackageWriteAPISchema;
  static readonly destSchema = MBSE_PartWriteAPISchema;
  static readonly originModelNames = ['MBSE_Package'] as const;
  static readonly destModelNames = ['MBSE_Part'] as const;
  static get origin_property() { return 'root_part'; }
  static get dest_property() { return 'package'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MBSE_Satisfaction: MBSE_Requirement.satisfyied_by -> MBSE_Action | MBSE_Part | MBSE_Port.requirements
export class MBSE_Satisfaction extends Relationship<MBSE_RequirementWriteAPI, MBSE_ActionWriteAPI | MBSE_PartWriteAPI | MBSE_PortWriteAPI> {
  static get relationshipName() { return 'MBSE_Satisfaction'; }
  static readonly originSchema = MBSE_RequirementWriteAPISchema;
  static readonly destSchema = undefined;
  static readonly originModelNames = ['MBSE_Requirement'] as const;
  static readonly destModelNames = ['MBSE_Action', 'MBSE_Part', 'MBSE_Port'] as const;
  static get origin_property() { return 'satisfyied_by'; }
  static get dest_property() { return 'requirements'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MBSE_SubactionOf: MBSE_Action.children -> MBSE_Action.parent
export class MBSE_SubactionOf extends Relationship<MBSE_ActionWriteAPI, MBSE_ActionWriteAPI> {
  static get relationshipName() { return 'MBSE_SubactionOf'; }
  static readonly originSchema = MBSE_ActionWriteAPISchema;
  static readonly destSchema = MBSE_ActionWriteAPISchema;
  static readonly originModelNames = ['MBSE_Action'] as const;
  static readonly destModelNames = ['MBSE_Action'] as const;
  static get origin_property() { return 'children'; }
  static get dest_property() { return 'parent'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MBSE_SubpartOf: MBSE_Part.children -> MBSE_Part.parent
export class MBSE_SubpartOf extends Relationship<MBSE_PartWriteAPI, MBSE_PartWriteAPI> {
  static get relationshipName() { return 'MBSE_SubpartOf'; }
  static readonly originSchema = MBSE_PartWriteAPISchema;
  static readonly destSchema = MBSE_PartWriteAPISchema;
  static readonly originModelNames = ['MBSE_Part'] as const;
  static readonly destModelNames = ['MBSE_Part'] as const;
  static get origin_property() { return 'children'; }
  static get dest_property() { return 'parent'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MemberOf: User | Group.groups -> Group.holders
export class MemberOf extends Relationship<UserWriteAPI | GroupWriteAPI, GroupWriteAPI> {
  static get relationshipName() { return 'MemberOf'; }
  static readonly originSchema = undefined;
  static readonly destSchema = GroupWriteAPISchema;
  static readonly originModelNames = ['User', 'Group'] as const;
  static readonly destModelNames = ['Group'] as const;
  static get origin_property() { return 'groups'; }
  static get dest_property() { return 'holders'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// MemberOfClosure: User.closure_groups -> Group.closure_holders
export class MemberOfClosure extends Relationship<UserWriteAPI, GroupWriteAPI> {
  static get relationshipName() { return 'MemberOfClosure'; }
  static readonly originSchema = UserWriteAPISchema;
  static readonly destSchema = GroupWriteAPISchema;
  static readonly originModelNames = ['User'] as const;
  static readonly destModelNames = ['Group'] as const;
  static get origin_property() { return 'closure_groups'; }
  static get dest_property() { return 'closure_holders'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

export interface MentionsProperties {
  paths: string[];
}

// Mentions: Expression.mentions -> RFLPElement.mentioned_in_expressions
export class Mentions extends Relationship<ExpressionWriteAPI, RFLPElementWriteAPI> {
  static get relationshipName() { return 'Mentions'; }
  static readonly originSchema = ExpressionWriteAPISchema;
  static readonly destSchema = RFLPElementWriteAPISchema;
  static readonly originModelNames = ['Expression'] as const;
  static readonly destModelNames = ['RFLPElement'] as const;
  static get origin_property() { return 'mentions'; }
  static get dest_property() { return 'mentioned_in_expressions'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = true as const;
  static readonly edgeProperties = {
    paths: { type: 'string[]', optional: false, default: undefined }
  } as const;
}

// NeedHasStakeholder: StakeholderNeed.stakeholders -> User.unknown
export class NeedHasStakeholder extends Relationship<StakeholderNeedWriteAPI, UserWriteAPI> {
  static get relationshipName() { return 'NeedHasStakeholder'; }
  static readonly originSchema = StakeholderNeedWriteAPISchema;
  static readonly destSchema = UserWriteAPISchema;
  static readonly originModelNames = ['StakeholderNeed'] as const;
  static readonly destModelNames = ['User'] as const;
  static get origin_property() { return 'stakeholders'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// NeedTransformedToRequirement: StakeholderNeed.transformed_to -> Requirement.transformed_from
export class NeedTransformedToRequirement extends Relationship<StakeholderNeedWriteAPI, RequirementWriteAPI> {
  static get relationshipName() { return 'NeedTransformedToRequirement'; }
  static readonly originSchema = StakeholderNeedWriteAPISchema;
  static readonly destSchema = RequirementWriteAPISchema;
  static readonly originModelNames = ['StakeholderNeed'] as const;
  static readonly destModelNames = ['Requirement'] as const;
  static get origin_property() { return 'transformed_to'; }
  static get dest_property() { return 'transformed_from'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// NumericAttributeHasCanonicalUnit: NumericAttribute.canonical_unit -> Unit.canonical_for_numeric_attributes
export class NumericAttributeHasCanonicalUnit extends Relationship<NumericAttributeWriteAPI, UnitWriteAPI> {
  static get relationshipName() { return 'NumericAttributeHasCanonicalUnit'; }
  static readonly originSchema = NumericAttributeWriteAPISchema;
  static readonly destSchema = UnitWriteAPISchema;
  static readonly originModelNames = ['NumericAttribute'] as const;
  static readonly destModelNames = ['Unit'] as const;
  static get origin_property() { return 'canonical_unit'; }
  static get dest_property() { return 'canonical_for_numeric_attributes'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// OfIsland: VersioningRow.island_root -> ScopedNode.unknown
export class OfIsland extends Relationship<VersioningRowWriteAPI, ScopedNodeWriteAPI> {
  static get relationshipName() { return 'OfIsland'; }
  static readonly originSchema = VersioningRowWriteAPISchema;
  static readonly destSchema = ScopedNodeWriteAPISchema;
  static readonly originModelNames = ['VersioningRow'] as const;
  static readonly destModelNames = ['ScopedNode'] as const;
  static get origin_property() { return 'island_root'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// OperatesOn: Task.target_node -> ScopedNode | Workspace.unknown
export class OperatesOn extends Relationship<TaskWriteAPI, ScopedNodeWriteAPI | WorkspaceWriteAPI> {
  static get relationshipName() { return 'OperatesOn'; }
  static readonly originSchema = TaskWriteAPISchema;
  static readonly destSchema = undefined;
  static readonly originModelNames = ['Task'] as const;
  static readonly destModelNames = ['ScopedNode', 'Workspace'] as const;
  static get origin_property() { return 'target_node'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// OwnedByUser: Requirement | Action | LogicalPart | Part.responsible_user -> User.unknown
export class OwnedByUser extends Relationship<RequirementWriteAPI | ActionWriteAPI | LogicalPartWriteAPI | PartWriteAPI, UserWriteAPI> {
  static get relationshipName() { return 'OwnedByUser'; }
  static readonly originSchema = undefined;
  static readonly destSchema = UserWriteAPISchema;
  static readonly originModelNames = ['Requirement', 'Action', 'LogicalPart', 'Part'] as const;
  static readonly destModelNames = ['User'] as const;
  static get origin_property() { return 'responsible_user'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// Owns: Organisation.workspaces -> Workspace.owner_org
export class Owns extends Relationship<OrganisationWriteAPI, WorkspaceWriteAPI> {
  static get relationshipName() { return 'Owns'; }
  static readonly originSchema = OrganisationWriteAPISchema;
  static readonly destSchema = WorkspaceWriteAPISchema;
  static readonly originModelNames = ['Organisation'] as const;
  static readonly destModelNames = ['Workspace'] as const;
  static get origin_property() { return 'workspaces'; }
  static get dest_property() { return 'owner_org'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ParentScope: SecurityScope.parent_scope -> SecurityScope.child_scopes
export class ParentScope extends Relationship<SecurityScopeWriteAPI, SecurityScopeWriteAPI> {
  static get relationshipName() { return 'ParentScope'; }
  static readonly originSchema = SecurityScopeWriteAPISchema;
  static readonly destSchema = SecurityScopeWriteAPISchema;
  static readonly originModelNames = ['SecurityScope'] as const;
  static readonly destModelNames = ['SecurityScope'] as const;
  static get origin_property() { return 'parent_scope'; }
  static get dest_property() { return 'child_scopes'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// PartBindsInterfacePort: LogicalPart | Part.bound_interface_ports -> InterfacePort.bound_to
export class PartBindsInterfacePort extends Relationship<LogicalPartWriteAPI | PartWriteAPI, InterfacePortWriteAPI> {
  static get relationshipName() { return 'PartBindsInterfacePort'; }
  static readonly originSchema = undefined;
  static readonly destSchema = InterfacePortWriteAPISchema;
  static readonly originModelNames = ['LogicalPart', 'Part'] as const;
  static readonly destModelNames = ['InterfacePort'] as const;
  static get origin_property() { return 'bound_interface_ports'; }
  static get dest_property() { return 'bound_to'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// PartComposedOf: PartDefinition.sub_parts -> PartDefinition.parent_part
export class PartComposedOf extends Relationship<PartDefinitionWriteAPI, PartDefinitionWriteAPI> {
  static get relationshipName() { return 'PartComposedOf'; }
  static readonly originSchema = PartDefinitionWriteAPISchema;
  static readonly destSchema = PartDefinitionWriteAPISchema;
  static readonly originModelNames = ['PartDefinition'] as const;
  static readonly destModelNames = ['PartDefinition'] as const;
  static get origin_property() { return 'sub_parts'; }
  static get dest_property() { return 'parent_part'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// Performs: PartDefinition.performed_actions -> ActionDefinition.performed_by
export class Performs extends Relationship<PartDefinitionWriteAPI, ActionDefinitionWriteAPI> {
  static get relationshipName() { return 'Performs'; }
  static readonly originSchema = PartDefinitionWriteAPISchema;
  static readonly destSchema = ActionDefinitionWriteAPISchema;
  static readonly originModelNames = ['PartDefinition'] as const;
  static readonly destModelNames = ['ActionDefinition'] as const;
  static get origin_property() { return 'performed_actions'; }
  static get dest_property() { return 'performed_by'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ProjectHasRootPart: Project.root_part -> LogicalPart.root_of
export class ProjectHasRootPart extends Relationship<ProjectWriteAPI, LogicalPartWriteAPI> {
  static get relationshipName() { return 'ProjectHasRootPart'; }
  static readonly originSchema = ProjectWriteAPISchema;
  static readonly destSchema = LogicalPartWriteAPISchema;
  static readonly originModelNames = ['Project'] as const;
  static readonly destModelNames = ['LogicalPart'] as const;
  static get origin_property() { return 'root_part'; }
  static get dest_property() { return 'root_of'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// ProjectUsesRepo: Project.uses_repos -> GitHubRepo.used_by_projects
export class ProjectUsesRepo extends Relationship<ProjectWriteAPI, GitHubRepoWriteAPI> {
  static get relationshipName() { return 'ProjectUsesRepo'; }
  static readonly originSchema = ProjectWriteAPISchema;
  static readonly destSchema = GitHubRepoWriteAPISchema;
  static readonly originModelNames = ['Project'] as const;
  static readonly destModelNames = ['GitHubRepo'] as const;
  static get origin_property() { return 'uses_repos'; }
  static get dest_property() { return 'used_by_projects'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ProposalBatchFromChangeImpact: ProposalBatch.change_impact -> ChangeImpact.unknown
export class ProposalBatchFromChangeImpact extends Relationship<ProposalBatchWriteAPI, ChangeImpactWriteAPI> {
  static get relationshipName() { return 'ProposalBatchFromChangeImpact'; }
  static readonly originSchema = ProposalBatchWriteAPISchema;
  static readonly destSchema = ChangeImpactWriteAPISchema;
  static readonly originModelNames = ['ProposalBatch'] as const;
  static readonly destModelNames = ['ChangeImpact'] as const;
  static get origin_property() { return 'change_impact'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ProposalBatchOfProject: ProposalBatch.project -> Project.proposal_batches
export class ProposalBatchOfProject extends Relationship<ProposalBatchWriteAPI, ProjectWriteAPI> {
  static get relationshipName() { return 'ProposalBatchOfProject'; }
  static readonly originSchema = ProposalBatchWriteAPISchema;
  static readonly destSchema = ProjectWriteAPISchema;
  static readonly originModelNames = ['ProposalBatch'] as const;
  static readonly destModelNames = ['Project'] as const;
  static get origin_property() { return 'project'; }
  static get dest_property() { return 'proposal_batches'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

export interface RFLPAllocationProperties {
  is_selected?: boolean;
  rationale?: string | null;
  allocation_kind?: AllocationKind;
  score?: number | null;
  rank?: number | null;
  spec_compliance?: string | null;
}

// RFLPAllocation: LogicalPart.allocated_to -> Part.allocation_sources
export class RFLPAllocation extends Relationship<LogicalPartWriteAPI, PartWriteAPI> {
  static get relationshipName() { return 'RFLPAllocation'; }
  static readonly originSchema = LogicalPartWriteAPISchema;
  static readonly destSchema = PartWriteAPISchema;
  static readonly originModelNames = ['LogicalPart'] as const;
  static readonly destModelNames = ['Part'] as const;
  static get origin_property() { return 'allocated_to'; }
  static get dest_property() { return 'allocation_sources'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = true as const;
  static readonly edgeProperties = {
    is_selected: { type: 'boolean', optional: true, default: false },
    rationale: { type: 'string | null', optional: true, default: undefined },
    allocation_kind: { type: 'AllocationKind', optional: true, default: 'AllocationKind.HARDWARE' },
    score: { type: 'number | null', optional: true, default: undefined },
    rank: { type: 'number | null', optional: true, default: undefined },
    spec_compliance: { type: 'string | null', optional: true, default: undefined }
  } as const;
}

// RFLPPerforms: LogicalPart.performs -> Action.performed_by
export class RFLPPerforms extends Relationship<LogicalPartWriteAPI, ActionWriteAPI> {
  static get relationshipName() { return 'RFLPPerforms'; }
  static readonly originSchema = LogicalPartWriteAPISchema;
  static readonly destSchema = ActionWriteAPISchema;
  static readonly originModelNames = ['LogicalPart'] as const;
  static readonly destModelNames = ['Action'] as const;
  static get origin_property() { return 'performs'; }
  static get dest_property() { return 'performed_by'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// RealizedByProject: LogicalPart.realized_by_project -> Project.unknown
export class RealizedByProject extends Relationship<LogicalPartWriteAPI, ProjectWriteAPI> {
  static get relationshipName() { return 'RealizedByProject'; }
  static readonly originSchema = LogicalPartWriteAPISchema;
  static readonly destSchema = ProjectWriteAPISchema;
  static readonly originModelNames = ['LogicalPart'] as const;
  static readonly destModelNames = ['Project'] as const;
  static get origin_property() { return 'realized_by_project'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// RealizesConnection: PhysicalPart.realizes_connections -> Connection.realized_by
export class RealizesConnection extends Relationship<PhysicalPartWriteAPI, ConnectionWriteAPI> {
  static get relationshipName() { return 'RealizesConnection'; }
  static readonly originSchema = PhysicalPartWriteAPISchema;
  static readonly destSchema = ConnectionWriteAPISchema;
  static readonly originModelNames = ['PhysicalPart'] as const;
  static readonly destModelNames = ['Connection'] as const;
  static get origin_property() { return 'realizes_connections'; }
  static get dest_property() { return 'realized_by'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ReferencesNode: LLMTask.references_nodes -> ScopedNode.unknown
export class ReferencesNode extends Relationship<LLMTaskWriteAPI, ScopedNodeWriteAPI> {
  static get relationshipName() { return 'ReferencesNode'; }
  static readonly originSchema = LLMTaskWriteAPISchema;
  static readonly destSchema = ScopedNodeWriteAPISchema;
  static readonly originModelNames = ['LLMTask'] as const;
  static readonly destModelNames = ['ScopedNode'] as const;
  static get origin_property() { return 'references_nodes'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// Refinement: RequirementDefinition.refined_requirements -> RequirementDefinition.abstract_requirement
export class Refinement extends Relationship<RequirementDefinitionWriteAPI, RequirementDefinitionWriteAPI> {
  static get relationshipName() { return 'Refinement'; }
  static readonly originSchema = RequirementDefinitionWriteAPISchema;
  static readonly destSchema = RequirementDefinitionWriteAPISchema;
  static readonly originModelNames = ['RequirementDefinition'] as const;
  static readonly destModelNames = ['RequirementDefinition'] as const;
  static get origin_property() { return 'refined_requirements'; }
  static get dest_property() { return 'abstract_requirement'; }
  static get cardinality() { return 'one2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// RequirementConflictsWith: Requirement.conflicts_with -> Requirement.conflicts_with_in
export class RequirementConflictsWith extends Relationship<RequirementWriteAPI, RequirementWriteAPI> {
  static get relationshipName() { return 'RequirementConflictsWith'; }
  static readonly originSchema = RequirementWriteAPISchema;
  static readonly destSchema = RequirementWriteAPISchema;
  static readonly originModelNames = ['Requirement'] as const;
  static readonly destModelNames = ['Requirement'] as const;
  static get origin_property() { return 'conflicts_with'; }
  static get dest_property() { return 'conflicts_with_in'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// RequirementDerives: Requirement.derives_to -> Requirement.derives_from
export class RequirementDerives extends Relationship<RequirementWriteAPI, RequirementWriteAPI> {
  static get relationshipName() { return 'RequirementDerives'; }
  static readonly originSchema = RequirementWriteAPISchema;
  static readonly destSchema = RequirementWriteAPISchema;
  static readonly originModelNames = ['Requirement'] as const;
  static readonly destModelNames = ['Requirement'] as const;
  static get origin_property() { return 'derives_to'; }
  static get dest_property() { return 'derives_from'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// RequirementHasStakeholder: Requirement.stakeholders -> User.unknown
export class RequirementHasStakeholder extends Relationship<RequirementWriteAPI, UserWriteAPI> {
  static get relationshipName() { return 'RequirementHasStakeholder'; }
  static readonly originSchema = RequirementWriteAPISchema;
  static readonly destSchema = UserWriteAPISchema;
  static readonly originModelNames = ['Requirement'] as const;
  static readonly destModelNames = ['User'] as const;
  static get origin_property() { return 'stakeholders'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// RequirementPart: Requirement.owning_part -> RFLPElement.unknown
export class RequirementPart extends Relationship<RequirementWriteAPI, RFLPElementWriteAPI> {
  static get relationshipName() { return 'RequirementPart'; }
  static readonly originSchema = RequirementWriteAPISchema;
  static readonly destSchema = RFLPElementWriteAPISchema;
  static readonly originModelNames = ['Requirement'] as const;
  static readonly destModelNames = ['RFLPElement'] as const;
  static get origin_property() { return 'owning_part'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// RequirementRefines: Requirement.refines -> Requirement.refined_by
export class RequirementRefines extends Relationship<RequirementWriteAPI, RequirementWriteAPI> {
  static get relationshipName() { return 'RequirementRefines'; }
  static readonly originSchema = RequirementWriteAPISchema;
  static readonly destSchema = RequirementWriteAPISchema;
  static readonly originModelNames = ['Requirement'] as const;
  static readonly destModelNames = ['Requirement'] as const;
  static get origin_property() { return 'refines'; }
  static get dest_property() { return 'refined_by'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// Satisfaction: ActionDefinition.satisfied_requirements -> RequirementDefinition.satisfying_actions
export class Satisfaction extends Relationship<ActionDefinitionWriteAPI, RequirementDefinitionWriteAPI> {
  static get relationshipName() { return 'Satisfaction'; }
  static readonly originSchema = ActionDefinitionWriteAPISchema;
  static readonly destSchema = RequirementDefinitionWriteAPISchema;
  static readonly originModelNames = ['ActionDefinition'] as const;
  static readonly destModelNames = ['RequirementDefinition'] as const;
  static get origin_property() { return 'satisfied_requirements'; }
  static get dest_property() { return 'satisfying_actions'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// Satisfies: Action | LogicalPart | Connection | InterfacePort | PhysicsPort | ControlPort.satisfies -> Requirement.satisfied_by
export class Satisfies extends Relationship<ActionWriteAPI | LogicalPartWriteAPI | ConnectionWriteAPI | InterfacePortWriteAPI | PhysicsPortWriteAPI | ControlPortWriteAPI, RequirementWriteAPI> {
  static get relationshipName() { return 'Satisfies'; }
  static readonly originSchema = undefined;
  static readonly destSchema = RequirementWriteAPISchema;
  static readonly originModelNames = ['Action', 'LogicalPart', 'Connection', 'InterfacePort', 'PhysicsPort', 'ControlPort'] as const;
  static readonly destModelNames = ['Requirement'] as const;
  static get origin_property() { return 'satisfies'; }
  static get dest_property() { return 'satisfied_by'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// SoftwarePartRealizedByRepo: SoftwarePart.realized_by_repo -> GitHubRepo.realizes_parts
export class SoftwarePartRealizedByRepo extends Relationship<SoftwarePartWriteAPI, GitHubRepoWriteAPI> {
  static get relationshipName() { return 'SoftwarePartRealizedByRepo'; }
  static readonly originSchema = SoftwarePartWriteAPISchema;
  static readonly destSchema = GitHubRepoWriteAPISchema;
  static readonly originModelNames = ['SoftwarePart'] as const;
  static readonly destModelNames = ['GitHubRepo'] as const;
  static get origin_property() { return 'realized_by_repo'; }
  static get dest_property() { return 'realizes_parts'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// SourceDocumentInWorkspace: SourceDocument.workspace -> Workspace.unknown
export class SourceDocumentInWorkspace extends Relationship<SourceDocumentWriteAPI, WorkspaceWriteAPI> {
  static get relationshipName() { return 'SourceDocumentInWorkspace'; }
  static readonly originSchema = SourceDocumentWriteAPISchema;
  static readonly destSchema = WorkspaceWriteAPISchema;
  static readonly originModelNames = ['SourceDocument'] as const;
  static readonly destModelNames = ['Workspace'] as const;
  static get origin_property() { return 'workspace'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// Specializes: SysMLType.general -> SysMLType.specific
export class Specializes extends Relationship<SysMLTypeWriteAPI, SysMLTypeWriteAPI> {
  static get relationshipName() { return 'Specializes'; }
  static readonly originSchema = SysMLTypeWriteAPISchema;
  static readonly destSchema = SysMLTypeWriteAPISchema;
  static readonly originModelNames = ['SysMLType'] as const;
  static readonly destModelNames = ['SysMLType'] as const;
  static get origin_property() { return 'general'; }
  static get dest_property() { return 'specific'; }
  static get cardinality() { return 'm2m' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// StandardForInterfacePort: InterfacePort.standard -> Standard.used_by_ports
export class StandardForInterfacePort extends Relationship<InterfacePortWriteAPI, StandardWriteAPI> {
  static get relationshipName() { return 'StandardForInterfacePort'; }
  static readonly originSchema = InterfacePortWriteAPISchema;
  static readonly destSchema = StandardWriteAPISchema;
  static readonly originModelNames = ['InterfacePort'] as const;
  static readonly destModelNames = ['Standard'] as const;
  static get origin_property() { return 'standard'; }
  static get dest_property() { return 'used_by_ports'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// StandardInWorkspace: Standard.workspace -> Workspace.unknown
export class StandardInWorkspace extends Relationship<StandardWriteAPI, WorkspaceWriteAPI> {
  static get relationshipName() { return 'StandardInWorkspace'; }
  static readonly originSchema = StandardWriteAPISchema;
  static readonly destSchema = WorkspaceWriteAPISchema;
  static readonly originModelNames = ['Standard'] as const;
  static readonly destModelNames = ['Workspace'] as const;
  static get origin_property() { return 'workspace'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// SubTaskOf: Task.parent_task -> Task.sub_tasks
export class SubTaskOf extends Relationship<TaskWriteAPI, TaskWriteAPI> {
  static get relationshipName() { return 'SubTaskOf'; }
  static readonly originSchema = TaskWriteAPISchema;
  static readonly destSchema = TaskWriteAPISchema;
  static readonly originModelNames = ['Task'] as const;
  static readonly destModelNames = ['Task'] as const;
  static get origin_property() { return 'parent_task'; }
  static get dest_property() { return 'sub_tasks'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// SuccessionScopedIn: Succession.parent_action -> Action.unknown
export class SuccessionScopedIn extends Relationship<SuccessionWriteAPI, ActionWriteAPI> {
  static get relationshipName() { return 'SuccessionScopedIn'; }
  static readonly originSchema = SuccessionWriteAPISchema;
  static readonly destSchema = ActionWriteAPISchema;
  static readonly originModelNames = ['Succession'] as const;
  static readonly destModelNames = ['Action'] as const;
  static get origin_property() { return 'parent_action'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = true as const;
  static readonly hasEdgeProperties = false as const;
}

// SuccessionSourceAction: Succession.source_action -> Action.outgoing_successions
export class SuccessionSourceAction extends Relationship<SuccessionWriteAPI, ActionWriteAPI> {
  static get relationshipName() { return 'SuccessionSourceAction'; }
  static readonly originSchema = SuccessionWriteAPISchema;
  static readonly destSchema = ActionWriteAPISchema;
  static readonly originModelNames = ['Succession'] as const;
  static readonly destModelNames = ['Action'] as const;
  static get origin_property() { return 'source_action'; }
  static get dest_property() { return 'outgoing_successions'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// SuccessionTargetAction: Succession.target_action -> Action.incoming_successions
export class SuccessionTargetAction extends Relationship<SuccessionWriteAPI, ActionWriteAPI> {
  static get relationshipName() { return 'SuccessionTargetAction'; }
  static readonly originSchema = SuccessionWriteAPISchema;
  static readonly destSchema = ActionWriteAPISchema;
  static readonly originModelNames = ['Succession'] as const;
  static readonly destModelNames = ['Action'] as const;
  static get origin_property() { return 'target_action'; }
  static get dest_property() { return 'incoming_successions'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// ToolResponsesSentIn: ToolCallResponse.sent_in_request -> ModelRequest.tool_return_parts
export class ToolResponsesSentIn extends Relationship<ToolCallResponseWriteAPI, ModelRequestWriteAPI> {
  static get relationshipName() { return 'ToolResponsesSentIn'; }
  static readonly originSchema = ToolCallResponseWriteAPISchema;
  static readonly destSchema = ModelRequestWriteAPISchema;
  static readonly originModelNames = ['ToolCallResponse'] as const;
  static readonly destModelNames = ['ModelRequest'] as const;
  static get origin_property() { return 'sent_in_request'; }
  static get dest_property() { return 'tool_return_parts'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// TriggeredByToolCall: Task.triggered_by -> ToolCallPart.spawned_task
export class TriggeredByToolCall extends Relationship<TaskWriteAPI, ToolCallPartWriteAPI> {
  static get relationshipName() { return 'TriggeredByToolCall'; }
  static readonly originSchema = TaskWriteAPISchema;
  static readonly destSchema = ToolCallPartWriteAPISchema;
  static readonly originModelNames = ['Task'] as const;
  static readonly destModelNames = ['ToolCallPart'] as const;
  static get origin_property() { return 'triggered_by'; }
  static get dest_property() { return 'spawned_task'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// UnitInWorkspace: Unit.workspace -> Workspace.unknown
export class UnitInWorkspace extends Relationship<UnitWriteAPI, WorkspaceWriteAPI> {
  static get relationshipName() { return 'UnitInWorkspace'; }
  static readonly originSchema = UnitWriteAPISchema;
  static readonly destSchema = WorkspaceWriteAPISchema;
  static readonly originModelNames = ['Unit'] as const;
  static readonly destModelNames = ['Workspace'] as const;
  static get origin_property() { return 'workspace'; }
  static get dest_property() { return 'unknown'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// UsesSystemPromptForRequest: ModelRequest.system_prompt -> SystemPrompt.used_by_requests
export class UsesSystemPromptForRequest extends Relationship<ModelRequestWriteAPI, SystemPromptWriteAPI> {
  static get relationshipName() { return 'UsesSystemPromptForRequest'; }
  static readonly originSchema = ModelRequestWriteAPISchema;
  static readonly destSchema = SystemPromptWriteAPISchema;
  static readonly originModelNames = ['ModelRequest'] as const;
  static readonly destModelNames = ['SystemPrompt'] as const;
  static get origin_property() { return 'system_prompt'; }
  static get dest_property() { return 'used_by_requests'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}

// WritesTo: StepTask.step -> Step.step_tasks
export class WritesTo extends Relationship<StepTaskWriteAPI, StepWriteAPI> {
  static get relationshipName() { return 'WritesTo'; }
  static readonly originSchema = StepTaskWriteAPISchema;
  static readonly destSchema = StepWriteAPISchema;
  static readonly originModelNames = ['StepTask'] as const;
  static readonly destModelNames = ['Step'] as const;
  static get origin_property() { return 'step'; }
  static get dest_property() { return 'step_tasks'; }
  static get cardinality() { return 'one2one' as const; }
  static readonly composition = false as const;
  static readonly hasEdgeProperties = false as const;
}